// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#AdminOpsPrompt {
  justify-content: flex-start;
}
#AdminOpsPrompt .ops-prompt-body {
  width: 100%;
  height: calc(100vh - var(--page-header-height));
  box-sizing: border-box;
  padding: 0 16px 16px;
  display: flex;
  flex-direction: row;
  gap: 16px;
  min-height: 0;
}
#AdminOpsPrompt .ops-prompt-loading {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
#AdminOpsPrompt .ops-ver-panel {
  flex-shrink: 0;
  width: 340px;
  display: flex;
  flex-direction: column;
  background: var(--white-color-lightest);
  border-radius: 8px;
  overflow: hidden;
  transition: width 0.2s ease;
  interpolate-size: allow-keywords;
}
#AdminOpsPrompt .ops-ver-panel .ops-ver-fade {
  transition: opacity 0.2s;
}
#AdminOpsPrompt .ops-ver-panel.is-collapsed {
  width: 128px;
}
#AdminOpsPrompt .ops-ver-panel.is-collapsed .ops-ver-fade {
  opacity: 0;
  pointer-events: none;
}
#AdminOpsPrompt .ops-ver-panel.is-collapsed .ops-ver-caret {
  transform: rotate(0deg);
}
#AdminOpsPrompt .ops-ver-panel.is-collapsed .ops-ver-summary {
  max-height: 0;
  opacity: 0;
  padding-top: 0;
  padding-bottom: 0;
}
#AdminOpsPrompt .ops-ver-panel.is-collapsed .ops-ver-row {
  height: 34px;
  min-height: 0;
}
#AdminOpsPrompt .ops-ver-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 0 14px;
  height: 51px;
  min-height: 51px;
  box-sizing: border-box;
  border-bottom: 1px solid var(--border-weak-color);
}
#AdminOpsPrompt .ops-ver-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  color: var(--dark-color-dark);
  min-height: 28px;
}
#AdminOpsPrompt .ops-ver-toggle .ops-ver-caret {
  font-size: 16px;
  transition: transform 0.2s;
  transform: rotate(180deg);
}
#AdminOpsPrompt .ops-ver-toggle .ops-ver-title {
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 1px;
  white-space: nowrap;
  line-height: 1;
}
#AdminOpsPrompt .ops-ver-summary {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  row-gap: 4px;
  padding: 7px 12px;
  width: 340px;
  box-sizing: border-box;
  background: var(--ops-panel-bg);
  overflow: hidden;
  max-height: 80px;
  transition: max-height 0.25s ease, opacity 0.2s, padding 0.25s ease;
  border-bottom: 1px solid var(--border-weak-color);
}
#AdminOpsPrompt .ops-ver-summary .ops-ver-summary-label {
  font-size: 9.5px;
  font-weight: 800;
  letter-spacing: 1px;
  color: var(--font_active_sub_color);
  white-space: nowrap;
}
#AdminOpsPrompt .ops-ver-chip {
  display: flex;
  align-items: center;
  gap: 4px;
  border-radius: 10px;
  cursor: pointer;
  height: 20px;
  padding: 0 8px;
  flex-shrink: 0;
  background: var(--white-color-lightest);
  border: 1px solid var(--ops-line);
}
#AdminOpsPrompt .ops-ver-chip:hover {
  background: var(--dark-color-dark-transparent-10);
}
#AdminOpsPrompt .ops-ver-chip .ops-ver-chip-label {
  font-size: 10px;
  font-family: var(--ops-mono);
  white-space: nowrap;
  color: var(--font_active_sub_color);
}
#AdminOpsPrompt .ops-ver-chip .ops-ver-chip-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--warning-color-main);
}
#AdminOpsPrompt .ops-ver-chip.is-current {
  background: var(--primary-color-lightest);
  border-color: var(--primary-color-main);
}
#AdminOpsPrompt .ops-ver-chip.is-current .ops-ver-chip-label {
  color: var(--primary-color-main);
  font-weight: 700;
}
#AdminOpsPrompt .ops-ver-list {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
}
#AdminOpsPrompt .ops-ver-empty {
  padding: 16px;
  font-size: 12px;
  color: var(--input-placeholder-color);
}
#AdminOpsPrompt .ops-ver-row {
  display: flex;
  align-items: stretch;
  border-bottom: 1px dashed var(--ops-line);
  overflow: hidden;
  box-sizing: border-box;
  height: auto;
  min-height: 92px;
  transition: height 0.25s ease, min-height 0.25s ease, background-color 0.3s;
}
#AdminOpsPrompt .ops-ver-row.is-selected {
  background: color-mix(in srgb, var(--primary-color-main) 6%, var(--white-color-lightest));
  box-shadow: inset 3px 0 0 var(--primary-color-main);
}
#AdminOpsPrompt .ops-ver-gutter {
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
  margin-left: 10px;
  margin-right: 6px;
}
#AdminOpsPrompt .ops-ver-gutter .ops-ver-gutter-inner {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  transition: transform 0.3s ease;
}
#AdminOpsPrompt .ops-ver-graph {
  display: block;
  overflow: visible;
}
#AdminOpsPrompt .ops-ver-graph path {
  fill: none;
  stroke: #d0d5dd;
  stroke-width: 1.5;
  stroke-linecap: round;
}
#AdminOpsPrompt .ops-ver-graph path.is-hl {
  stroke: var(--primary-color-main);
  stroke-width: 2;
}
#AdminOpsPrompt .ops-ver-graph path.is-dashed {
  stroke-dasharray: 3 3;
}
#AdminOpsPrompt .ops-ver-graph .ops-ver-graph-dot {
  fill: var(--white-color-lightest);
  stroke: var(--font_active_hidden_color);
  stroke-width: 2.2;
}
#AdminOpsPrompt .ops-ver-graph .ops-ver-graph-dot.is-lineage {
  stroke: var(--primary-color-main);
}
#AdminOpsPrompt .ops-ver-graph .ops-ver-graph-dot.is-filled {
  fill: var(--primary-color-main);
  stroke: var(--primary-color-main);
}
#AdminOpsPrompt .ops-ver-graph .ops-ver-graph-dot.is-draft {
  fill: var(--white-color-lightest);
  stroke: var(--warning-color-main);
  stroke-dasharray: 2.5 2;
}
#AdminOpsPrompt .ops-ver-content {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 7px 10px 7px 0;
  box-sizing: border-box;
}
#AdminOpsPrompt .ops-ver-line1 {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  height: 20px;
}
#AdminOpsPrompt .ops-ver-line1 .ops-ver-label {
  font-size: 12px;
  line-height: 16px;
  font-family: var(--ops-mono);
  flex-shrink: 0;
  font-weight: 600;
}
#AdminOpsPrompt .ops-ver-line1 .ops-ver-meta {
  flex: 1 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 6px;
}
#AdminOpsPrompt .ops-ver-line1 .ops-ver-date {
  min-width: 0;
  font-size: 11px;
  font-family: var(--ops-mono);
  color: var(--disabled-font-color);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
#AdminOpsPrompt .ops-ver-row.is-deployed .ops-ver-label {
  color: var(--primary-color-main);
  font-weight: 700;
}
#AdminOpsPrompt .ops-ver-star {
  width: 20px;
  height: 20px;
  min-height: 20px;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--input-placeholder-color);
}
#AdminOpsPrompt .ops-ver-star .bi {
  font-size: 14px;
  line-height: 14px;
}
#AdminOpsPrompt .ops-ver-star:hover, #AdminOpsPrompt .ops-ver-star.is-on {
  color: #e0a400;
}
#AdminOpsPrompt .ops-ver-star:hover {
  background: var(--ops-draft-bg);
}
#AdminOpsPrompt .ops-ver-spacer {
  flex: 1 1;
  min-width: 4px;
}
#AdminOpsPrompt .ops-ver-line2 {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  min-width: 0;
  min-height: 18px;
}
#AdminOpsPrompt .ops-ver-line2 .ops-ver-message {
  min-width: 0;
  font-size: 12px;
  color: var(--dark-color-main);
  line-height: 18px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
#AdminOpsPrompt .ops-ver-line2 .ops-ver-message.is-editable {
  cursor: text;
}
#AdminOpsPrompt .ops-ver-memo-edit,
#AdminOpsPrompt .ops-ver-memo-btn {
  width: 18px;
  height: 18px;
  min-height: 18px;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--input-placeholder-color);
}
#AdminOpsPrompt .ops-ver-memo-edit .bi,
#AdminOpsPrompt .ops-ver-memo-btn .bi {
  font-size: 12px;
  line-height: 12px;
}
#AdminOpsPrompt .ops-ver-memo-edit:hover,
#AdminOpsPrompt .ops-ver-memo-btn:hover {
  color: var(--dark-color-main);
  background: var(--dark-color-dark-transparent-10);
}
#AdminOpsPrompt .ops-ver-memo-edit:disabled,
#AdminOpsPrompt .ops-ver-memo-btn:disabled {
  opacity: 0.4;
  cursor: default;
  background: transparent;
}
#AdminOpsPrompt .ops-ver-memo-btn.is-ok:not(:disabled) {
  color: var(--primary-color-main);
}
#AdminOpsPrompt .ops-ver-memo-form {
  flex: 1 1;
  min-width: 0;
  display: flex;
  align-items: flex-start;
  gap: 2px;
}
#AdminOpsPrompt .ops-ver-memo-input {
  flex: 1 1;
  min-width: 0;
  field-sizing: content;
  min-height: 20px;
  max-height: 58px;
  margin: -1px 2px -1px 0;
  padding: 0 6px;
  box-sizing: border-box;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  background: var(--white-color-lightest);
  font-family: inherit;
  font-size: 12px;
  line-height: 18px;
  color: var(--dark-color-main);
  outline: none;
  resize: none;
  overflow-y: auto;
}
#AdminOpsPrompt .ops-ver-memo-input:focus {
  border-color: var(--primary-color-main);
}
#AdminOpsPrompt .ops-ver-memo-input.is-error {
  border-color: var(--ops-error);
}
#AdminOpsPrompt .ops-ver-memo-input:disabled {
  opacity: 0.6;
}
#AdminOpsPrompt .ops-ver-actions {
  display: flex;
  gap: 6px;
  margin-top: 2px;
}
#AdminOpsPrompt .ops-ver-action {
  height: 26px;
  min-height: 26px;
  padding: 0 10px;
  border-radius: 6px;
  font-size: 12px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  box-sizing: border-box;
  box-shadow: 0 1px 2px rgba(46, 50, 66, 0.12);
  border: 1px solid var(--border-color);
  background: var(--white-color-lightest);
  color: var(--dark-color-dark);
  cursor: pointer;
  white-space: nowrap;
}
#AdminOpsPrompt .ops-ver-action .bi {
  font-size: 14px;
}
#AdminOpsPrompt .ops-ver-action:hover {
  background: #f1f2f4;
  border-color: #9aa1ae;
}
#AdminOpsPrompt .ops-ver-action[aria-disabled=true] {
  color: var(--input-placeholder-color);
  border-color: var(--ops-line);
  box-shadow: none;
  cursor: not-allowed;
}
#AdminOpsPrompt .ops-ver-action[aria-disabled=true]:hover {
  background: var(--white-color-lightest);
  border-color: var(--ops-line);
}
#AdminOpsPrompt .ops-ver-action.ops-ver-apply:not([aria-disabled=true]) {
  border-color: var(--primary-color-main);
  color: var(--primary-color-main);
}
#AdminOpsPrompt .ops-ver-action.ops-ver-apply:not([aria-disabled=true]):hover {
  background: var(--primary-color-main);
  border-color: var(--primary-color-main);
  color: var(--white-color-lightest);
}
#AdminOpsPrompt .ops-editor {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  background: var(--white-color-lightest);
  border-radius: 8px;
  overflow: hidden;
}
#AdminOpsPrompt .ops-editor-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0 16px;
  min-height: 51px;
  box-sizing: border-box;
  border-bottom: 1px solid var(--border-weak-color);
  flex-wrap: wrap;
  row-gap: 8px;
}
#AdminOpsPrompt .ops-editor-switch {
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1 1 200px;
}
#AdminOpsPrompt .ops-editor-switch-tabs {
  width: clamp(0px, (100% - 380px) * 999, 100%);
  overflow: hidden;
  flex-shrink: 0;
}
#AdminOpsPrompt .ops-editor-switch-select {
  width: clamp(0px, (380px - 100%) * 999, 240px);
  max-width: 100%;
  overflow: hidden;
  flex-shrink: 0;
}
#AdminOpsPrompt .ops-editor-switch-select .ops-select-pill-wrap {
  width: max-content;
  max-width: 100%;
}
#AdminOpsPrompt .ops-seg {
  width: max-content;
  display: flex;
  padding: 3px;
  gap: 2px;
  border-radius: 18px;
  background: var(--ops-seg-bg);
  box-sizing: border-box;
}
#AdminOpsPrompt .ops-seg-btn {
  height: 26px;
  min-height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  line-height: 1;
  box-sizing: border-box;
  padding: 0 14px;
  border: none;
  border-radius: 13px;
  font-family: inherit;
  font-size: 12.5px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.2s, color 0.2s;
  background: transparent;
  color: var(--dark-color-main);
}
#AdminOpsPrompt .ops-seg-btn.is-active {
  background: var(--white-color-lightest);
  color: var(--dark-color-dark);
  font-weight: 700;
  box-shadow: 0 1px 2px rgba(46, 50, 66, 0.18);
}
#AdminOpsPrompt .ops-seg-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--warning-color-main);
  flex-shrink: 0;
}
#AdminOpsPrompt .ops-select-pill-wrap {
  position: relative;
  display: flex;
  align-items: center;
}
#AdminOpsPrompt .ops-select-pill-wrap .bi-chevron-down {
  position: absolute;
  right: 12px;
  font-size: 12px;
  color: var(--dark-color-main);
  pointer-events: none;
}
#AdminOpsPrompt .ops-select-pill-wrap .ops-select-dot {
  position: absolute;
  left: 12px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--warning-color-main);
  pointer-events: none;
}
#AdminOpsPrompt .ops-select-pill-wrap.has-dot .ops-select-pill {
  padding-left: 26px;
}
#AdminOpsPrompt .ops-select-pill {
  appearance: none;
  -webkit-appearance: none;
  height: 32px;
  box-sizing: border-box;
  padding: 0 32px 0 14px;
  border: 1px solid var(--border-weak-color);
  border-radius: 16px;
  background: var(--white-color-lightest);
  color: var(--dark-color-dark);
  font-family: inherit;
  font-size: 13px;
  cursor: pointer;
  max-width: 220px;
}
#AdminOpsPrompt .ops-select-pill.is-bold {
  font-weight: 700;
}
#AdminOpsPrompt .ops-editor-head-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
#AdminOpsPrompt .ops-unsaved-note {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  line-height: 1;
  font-size: 11.5px;
  font-weight: 600;
  color: var(--ops-draft-fg);
  white-space: nowrap;
}
#AdminOpsPrompt .ops-unsaved-dot,
#AdminOpsPrompt .ops-pane-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--warning-color-main);
  flex-shrink: 0;
}
#AdminOpsPrompt .ops-editor-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 3px 16px;
  min-height: 35px;
  box-sizing: border-box;
  border-bottom: 1px solid var(--border-weak-color);
  background: var(--white-color-light);
  flex-wrap: wrap;
  row-gap: 4px;
}
#AdminOpsPrompt .ops-md-tools {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-wrap: wrap;
}
#AdminOpsPrompt .ops-md-tool {
  width: 28px;
  height: 28px;
  min-height: 28px;
  padding: 0;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  background: transparent;
  color: var(--dark-color-main);
  outline: 1.5px solid transparent;
  outline-offset: -1px;
}
#AdminOpsPrompt .ops-md-tool .bi {
  font-size: 15px;
}
#AdminOpsPrompt .ops-md-tool:hover {
  background: var(--dark-color-dark-transparent-10);
}
#AdminOpsPrompt .ops-md-tool.is-active {
  box-shadow: inset 0 0 0 999px var(--primary-color-lightest);
  outline-color: var(--primary-color-main);
  color: var(--primary-color-main);
}
#AdminOpsPrompt .ops-model-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
  flex-shrink: 0;
  font-size: 11.5px;
  line-height: 1;
  color: var(--font_active_sub_color);
  white-space: nowrap;
}
#AdminOpsPrompt .ops-model-badge .bi {
  font-size: 12px;
}
#AdminOpsPrompt .ops-lint-count {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
}
#AdminOpsPrompt .ops-lint-count .bi {
  font-size: 11px;
}
#AdminOpsPrompt .ops-lint-count.is-error {
  color: var(--ops-error);
}
#AdminOpsPrompt .ops-lint-count.is-warn {
  color: var(--ops-warn-text);
}
#AdminOpsPrompt .ops-lint-count.is-warn .bi {
  color: var(--ops-warn);
}
#AdminOpsPrompt .ops-diff-summary {
  font-size: 11px;
  color: var(--ops-inuse-fg);
}
#AdminOpsPrompt .ops-diff-summary.is-diff {
  color: var(--ops-draft-fg);
}
#AdminOpsPrompt .ops-char-count {
  font-size: 11px;
  color: var(--font_active_sub_color);
}
#AdminOpsPrompt .ops-editor-split {
  flex: 1 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-wrap: wrap;
  align-content: stretch;
  overflow: hidden;
}
#AdminOpsPrompt .ops-pane {
  min-width: 0;
  min-height: 0;
  contain: size;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
#AdminOpsPrompt .ops-pane.is-first {
  flex: 0 0 max(var(--ops-split, 50%), clamp(0px, (560px - 100%) * 999, 100%));
}
#AdminOpsPrompt .ops-pane.is-second {
  flex: 1 1 clamp(0px, (560px - 100%) * 999, 100%);
  border-top: 1px solid var(--border-weak-color);
  margin-top: -1px;
}
#AdminOpsPrompt .ops-pane-head {
  height: 34px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 0 12px 0 14px;
  box-sizing: border-box;
  background: var(--white-color-light);
  border-bottom: 1px solid var(--ops-line);
  overflow: hidden;
  cursor: text;
  transition: background-color 0.15s;
}
#AdminOpsPrompt .ops-pane.is-focused .ops-pane-head {
  background: var(--primary-color-lightest);
}
#AdminOpsPrompt .ops-pane.is-focused .ops-pane-head .ops-pane-title {
  color: var(--primary-color-main);
}
#AdminOpsPrompt .ops-pane-title {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.5px;
  white-space: nowrap;
  color: var(--dark-color-dark);
}
#AdminOpsPrompt .ops-pane-title-text {
  cursor: pointer;
}
#AdminOpsPrompt .ops-pane-outline-btn {
  width: 24px;
  height: 24px;
  min-height: 24px;
  padding: 0;
  margin-left: -6px;
  border-radius: 6px;
  border: 1px solid var(--border-weak-color);
  background: var(--white-color-lightest);
  color: var(--dark-color-main);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
}
#AdminOpsPrompt .ops-pane-outline-btn .bi {
  font-size: 13px;
  line-height: 1;
}
#AdminOpsPrompt .ops-pane-outline-btn:hover {
  border-color: var(--dark-color-main);
}
#AdminOpsPrompt .ops-pane-outline-btn.is-open {
  background: var(--primary-color-lightest);
  color: var(--primary-color-main);
  border-color: var(--primary-color-main);
}
#AdminOpsPrompt .ops-pane-stats {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
}
#AdminOpsPrompt .ops-pane-discard {
  height: 22px;
  min-height: 22px;
  padding: 0 8px;
  border-radius: 11px;
  background: var(--white-color-lightest);
  border: 1px solid var(--border-weak-color);
  color: var(--dark-color-dark);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  line-height: 1;
  font-family: inherit;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
  flex-shrink: 0;
}
#AdminOpsPrompt .ops-pane-discard .bi {
  font-size: 12px;
  line-height: 1;
}
#AdminOpsPrompt .ops-pane-discard:hover {
  background: var(--dark-color-main);
  color: #E8E9F1;
  border-color: var(--dark-color-main);
}
#AdminOpsPrompt .ops-pane-main {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: row;
}
#AdminOpsPrompt .ops-split-handle {
  position: relative;
  flex: 0 0 auto;
  width: clamp(0px, (100% - 560px) * 999, 11px);
  margin: 0 calc(-1 * clamp(0px, (100% - 560px) * 999, 5px));
  contain: size;
  overflow: hidden;
  z-index: 2;
  cursor: col-resize;
  display: flex;
  justify-content: center;
  touch-action: none;
}
#AdminOpsPrompt .ops-split-handle .ops-split-line {
  width: 1px;
  height: 100%;
  background: var(--border-weak-color);
  transition: background-color 0.15s;
}
#AdminOpsPrompt .ops-split-handle .ops-split-grip {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 14px;
  height: 34px;
  border-radius: 7px;
  background: var(--white-color-lightest);
  border: 1px solid var(--border-weak-color);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9aa0ad;
  box-shadow: 0 1px 2px rgba(46, 50, 66, 0.12);
}
#AdminOpsPrompt .ops-split-handle .ops-split-grip .bi {
  font-size: 12px;
  line-height: 1;
}
#AdminOpsPrompt .ops-split-handle.is-dragging .ops-split-line {
  width: 2px;
  background: var(--primary-color-main);
}
#AdminOpsPrompt .ops-split-handle.is-dragging .ops-split-grip {
  border-color: var(--primary-color-main);
  color: var(--primary-color-main);
}
#AdminOpsPrompt .ops-outline {
  width: 176px;
  flex-shrink: 0;
  border-right: 1px solid var(--ops-line);
  overflow-y: auto;
  padding: 10px 0;
  box-sizing: border-box;
  background: var(--ops-panel-bg);
}
#AdminOpsPrompt .ops-outline .ops-outline-title {
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 1.5px;
  color: var(--font_active_sub_color);
  padding: 0 12px 8px;
}
#AdminOpsPrompt .ops-outline .ops-outline-empty {
  font-size: 11px;
  color: var(--input-placeholder-color);
  padding: 0 12px;
}
#AdminOpsPrompt .ops-outline-item {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  width: 100%;
  border: none;
  cursor: pointer;
  text-align: left;
  padding: 4px 10px 4px 0;
  background: transparent;
  color: var(--dark-color-main);
}
#AdminOpsPrompt .ops-outline-item:hover {
  background: var(--dark-color-dark-transparent-10);
}
#AdminOpsPrompt .ops-outline-item .ops-outline-level {
  font-size: 9px;
  line-height: 17px;
  height: 17px;
  color: var(--input-placeholder-color);
  flex-shrink: 0;
  font-family: var(--ops-mono);
}
#AdminOpsPrompt .ops-outline-item .ops-outline-text {
  font-size: 11.5px;
  line-height: 17px;
  word-break: break-word;
  flex: 1 1;
  min-width: 0;
}
#AdminOpsPrompt .ops-outline-item .ops-outline-warn {
  height: 17px;
  font-size: 11px;
  color: var(--ops-warn);
}
#AdminOpsPrompt .ops-outline-item.is-current {
  background: var(--primary-color-lightest);
  color: var(--primary-color-main);
  font-weight: 700;
}
#AdminOpsPrompt .ops-gutter {
  overflow: hidden;
  background: var(--ops-panel-bg);
  border-right: 1px solid var(--ops-line);
  position: relative;
  flex-shrink: 0;
  box-sizing: content-box;
  transition: width 0.15s;
}
#AdminOpsPrompt .ops-gutter .ops-gutter-inner {
  will-change: transform;
}
#AdminOpsPrompt .ops-gutter-line {
  height: 21px;
  display: flex;
  align-items: stretch;
}
#AdminOpsPrompt .ops-gutter-line .ops-gutter-bar {
  width: 3px;
  flex-shrink: 0;
}
#AdminOpsPrompt .ops-gutter-line .ops-gutter-bar.is-added {
  background: var(--success-color-main);
}
#AdminOpsPrompt .ops-gutter-line .ops-gutter-bar.is-changed {
  background: var(--warning-color-main);
}
#AdminOpsPrompt .ops-gutter-line .ops-gutter-bar.is-removed {
  background: var(--danger-color-main);
}
#AdminOpsPrompt .ops-gutter-line .ops-gutter-num {
  flex: 1 1;
  text-align: right;
  padding: 0 8px 0 6px;
  font-size: 11px;
  font-family: var(--ops-mono);
  line-height: 22px;
  color: var(--input-placeholder-color);
}
#AdminOpsPrompt .ops-gutter-line.is-error {
  background: var(--ops-error-bg);
}
#AdminOpsPrompt .ops-gutter-line.is-error .ops-gutter-num {
  color: var(--ops-error-text);
}
#AdminOpsPrompt .ops-gutter-line.is-warn {
  background: var(--ops-warn-bg);
}
#AdminOpsPrompt .ops-gutter-line.is-warn .ops-gutter-num {
  color: var(--ops-warn-text);
}
#AdminOpsPrompt .ops-editor-area {
  flex: 1 1;
  min-width: 0;
  position: relative;
  display: flex;
  overflow: hidden;
}
#AdminOpsPrompt .ops-band-layer {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
}
#AdminOpsPrompt .ops-band-layer .ops-band-inner {
  position: relative;
  will-change: transform;
}
#AdminOpsPrompt .ops-band {
  position: absolute;
  left: 0;
  right: 0;
  height: 21px;
  box-sizing: border-box;
}
#AdminOpsPrompt .ops-band .ops-band-msg {
  position: absolute;
  right: 12px;
  top: 0;
  height: 20px;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 10.5px;
  font-weight: 600;
  white-space: nowrap;
}
#AdminOpsPrompt .ops-band .ops-band-msg .bi {
  font-size: 11px;
}
#AdminOpsPrompt .ops-band.is-error {
  background: var(--ops-error-bg);
  border-bottom: 1px dashed var(--ops-error-border);
}
#AdminOpsPrompt .ops-band.is-error .ops-band-msg {
  color: var(--ops-error-text);
}
#AdminOpsPrompt .ops-band.is-error .bi {
  color: var(--ops-error);
}
#AdminOpsPrompt .ops-band.is-warn {
  background: var(--ops-warn-bg);
  border-bottom: 1px dashed var(--ops-warn-border);
}
#AdminOpsPrompt .ops-band.is-warn .ops-band-msg {
  color: var(--ops-warn-text);
}
#AdminOpsPrompt .ops-band.is-warn .bi {
  color: var(--ops-warn);
}
#AdminOpsPrompt .ops-editor-textarea {
  flex: 1 1;
  min-width: 0;
  border: none;
  outline: none;
  resize: none;
  padding: 12px 16px 12px 12px;
  box-sizing: border-box;
  font-family: var(--ops-mono);
  font-size: 13px;
  line-height: 21px;
  color: var(--dark-color-dark);
  background: transparent;
  position: relative;
  white-space: pre;
  overflow: auto;
  tab-size: 2;
}
#AdminOpsPrompt .ops-editor-textarea[readonly] {
  color: var(--dark-color-main);
}
#AdminOpsPrompt .ops-auto-info {
  position: relative;
  display: inline-flex;
  margin-left: 8px;
}
#AdminOpsPrompt .ops-auto-info-button {
  height: 24px;
  min-height: 24px;
  padding: 0 10px;
  border-radius: 12px;
  border: 1px solid var(--ops-latest-border);
  background: var(--ops-latest-bg);
  color: var(--ops-latest-fg);
  font-size: 11.5px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}
#AdminOpsPrompt .ops-auto-info-button .bi {
  font-size: 12px;
}
#AdminOpsPrompt .ops-auto-info-button:hover, #AdminOpsPrompt .ops-auto-info-button.is-active {
  border-color: var(--ops-latest-fg);
}
#AdminOpsPrompt .ops-auto-info-pop {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 20;
  width: 360px;
  padding: 12px;
  box-sizing: border-box;
  border-radius: 8px;
  border: 1px solid var(--border-weak-color);
  background: var(--white-color-lightest);
  box-shadow: 0 6px 20px rgba(46, 50, 66, 0.16);
  display: flex;
  flex-direction: column;
  gap: 8px;
}
#AdminOpsPrompt .ops-auto-info-lead {
  font-size: 12px;
  line-height: 1.6;
  color: var(--dark-color-dark);
}
#AdminOpsPrompt .ops-var-tool {
  position: relative;
  display: inline-flex;
}
#AdminOpsPrompt .ops-var-menu {
  position: absolute;
  z-index: 20;
  display: flex;
  flex-direction: column;
  max-height: 280px;
  box-sizing: border-box;
  border-radius: 8px;
  border: 1px solid var(--border-weak-color);
  background: var(--white-color-lightest);
  box-shadow: 0 6px 20px rgba(46, 50, 66, 0.16);
  overflow: hidden;
}
#AdminOpsPrompt .ops-var-list {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 4px;
}
#AdminOpsPrompt .ops-var-item {
  padding: 6px 10px;
  border-radius: 6px;
  cursor: pointer;
}
#AdminOpsPrompt .ops-var-item.is-active {
  background: var(--primary-color-lightest);
}
#AdminOpsPrompt .ops-var-item-head {
  display: flex;
  align-items: baseline;
  gap: 8px;
  min-width: 0;
}
#AdminOpsPrompt .ops-var-item-head code {
  flex-shrink: 0;
  font-family: var(--ops-mono);
  font-size: 12.5px;
  font-weight: 700;
  color: var(--dark-color-dark);
}
#AdminOpsPrompt .ops-var-item.is-active .ops-var-item-head code {
  color: var(--primary-color-main);
}
#AdminOpsPrompt .ops-var-label {
  min-width: 0;
  font-size: 12px;
  color: var(--dark-color-dark);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
#AdminOpsPrompt .ops-var-example {
  margin-top: 2px;
  font-size: 11px;
  color: var(--font_active_sub_color);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
#AdminOpsPrompt .ops-var-hint {
  flex-shrink: 0;
  padding: 5px 12px;
  border-top: 1px solid var(--ops-line);
  background: var(--white-color-light);
  font-size: 10.5px;
  color: var(--font_active_sub_color);
}

.ops-diff-dialog.ops-dialog-overlay .ops-dialog {
  height: 100%;
  max-height: none;
}
.ops-diff-dialog .ops-dialog-title-area {
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}
.ops-diff-dialog .ops-diff-count {
  margin-left: 12px;
  color: var(--font_active_sub_color);
}
.ops-diff-dialog .ops-diff-body {
  padding: 0;
  background: var(--white-color-lightest);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.ops-diff-dialog .ops-diff-toggle {
  display: flex;
  padding: 3px;
  gap: 2px;
  border-radius: 18px;
  background: var(--ops-seg-bg);
  box-sizing: border-box;
}
.ops-diff-dialog .ops-diff-mode {
  height: 26px;
  min-height: 26px;
  padding: 0 14px;
  border: none;
  border-radius: 13px;
  font-family: inherit;
  font-size: 12.5px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  line-height: 1;
  transition: background-color 0.2s, color 0.2s;
  background: transparent;
  color: var(--dark-color-main);
}
.ops-diff-dialog .ops-diff-mode.is-active {
  background: var(--white-color-lightest);
  color: var(--dark-color-dark);
  font-weight: 700;
  box-shadow: 0 1px 2px rgba(46, 50, 66, 0.18);
}
.ops-diff-dialog .ops-diff-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 56px 24px;
  text-align: center;
}
.ops-diff-dialog .ops-diff-empty .bi {
  font-size: 32px;
  line-height: 1;
  color: #9aa0ad;
}
.ops-diff-dialog .ops-diff-empty-title {
  font-size: 14px;
  font-weight: 700;
  color: var(--dark-color-dark);
}
.ops-diff-dialog .ops-diff-empty-sub {
  font-size: 12px;
  color: var(--dark-color-main);
}
.ops-diff-dialog .ops-diff-empty-btn {
  margin-top: 4px;
  height: 30px;
  min-height: 30px;
  padding: 0 14px;
  border-radius: 15px;
  border: 1px solid var(--border-weak-color);
  background: var(--white-color-lightest);
  color: var(--dark-color-dark);
  font-family: inherit;
  font-size: 12px;
  cursor: pointer;
}
.ops-diff-dialog .ops-diff-empty-btn:hover {
  background: var(--dark-color-dark-transparent-10);
}
.ops-diff-dialog .ops-diff-cols {
  display: flex;
  border-bottom: 1px solid var(--ops-line);
  background: var(--white-color-light);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 1px;
  color: var(--dark-color-main);
  flex-shrink: 0;
}
.ops-diff-dialog .ops-diff-cols .ops-diff-col-title {
  flex: 1 1;
  padding: 8px 16px;
}
.ops-diff-dialog .ops-diff-cols .ops-diff-col-title:first-child {
  border-right: 1px solid var(--ops-line);
}
.ops-diff-dialog .ops-diff-none {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  background: var(--white-color-light);
  border-bottom: 1px solid var(--ops-line);
  font-size: 12px;
  color: var(--dark-color-main);
  flex-shrink: 0;
}
.ops-diff-dialog .ops-diff-scroll {
  flex: 1 1;
  min-height: 0;
  overflow: auto;
  position: relative;
  background: var(--white-color-lightest);
}
.ops-diff-dialog .ops-diff-gap {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 4px 0;
  border: none;
  border-top: 1px solid var(--ops-line);
  border-bottom: 1px solid var(--ops-line);
  background: #f3f5f8;
  font-family: inherit;
  font-size: 11px;
  color: var(--dark-color-main);
  cursor: pointer;
}
.ops-diff-dialog .ops-diff-gap .bi {
  font-size: 11px;
}
.ops-diff-dialog .ops-diff-gap:hover {
  background: #e8ecf2;
  color: var(--dark-color-dark);
}
.ops-diff-dialog .ops-diff-line {
  display: flex;
  align-items: stretch;
  position: relative;
}
.ops-diff-dialog .ops-diff-line .ops-diff-cur {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: var(--dark-color-dark);
  z-index: 1;
}
.ops-diff-dialog .ops-diff-line .ops-diff-half {
  flex: 1 1;
  min-width: 0;
  display: flex;
}
.ops-diff-dialog .ops-diff-line .ops-diff-half.is-left {
  border-right: 1px solid var(--ops-line);
}
.ops-diff-dialog .ops-diff-line .ops-diff-ln {
  width: 44px;
  min-width: 44px;
  text-align: right;
  padding: 0 6px 0 0;
  font-size: 10.5px;
  line-height: 22px;
  font-family: var(--ops-mono);
  color: #b2bcca;
  -webkit-user-select: none;
          user-select: none;
  box-sizing: border-box;
}
.ops-diff-dialog .ops-diff-line .ops-diff-sign {
  width: 18px;
  min-width: 18px;
  text-align: center;
  font-size: 12px;
  line-height: 22px;
  font-family: var(--ops-mono);
  font-weight: 700;
  -webkit-user-select: none;
          user-select: none;
}
.ops-diff-dialog .ops-diff-line .is-left .ops-diff-sign {
  color: #c8394f;
}
.ops-diff-dialog .ops-diff-line .is-right .ops-diff-sign {
  color: #1f7a5e;
}
.ops-diff-dialog .ops-diff-line .ops-diff-text {
  flex: 1 1;
  min-width: 0;
  font-size: 13px;
  line-height: 22px;
  white-space: pre-wrap;
  word-break: break-word;
  padding-right: 16px;
}
.ops-diff-dialog .ops-diff-line .ops-diff-hl {
  border-radius: 2px;
}
.ops-diff-dialog .ops-diff-line.is-eq .is-left .ops-diff-text {
  color: var(--dark-color-main);
}
.ops-diff-dialog .ops-diff-line.is-eq .is-right .ops-diff-text {
  color: var(--dark-color-dark);
}
.ops-diff-dialog .ops-diff-line.is-chg .is-left, .ops-diff-dialog .ops-diff-line.is-del .is-left {
  background: #fff1f3;
}
.ops-diff-dialog .ops-diff-line.is-chg .is-left .ops-diff-text, .ops-diff-dialog .ops-diff-line.is-del .is-left .ops-diff-text {
  color: #a32a3e;
}
.ops-diff-dialog .ops-diff-line.is-chg .is-left .ops-diff-hl, .ops-diff-dialog .ops-diff-line.is-del .is-left .ops-diff-hl {
  background: #ffc6d0;
}
.ops-diff-dialog .ops-diff-line.is-chg .is-right, .ops-diff-dialog .ops-diff-line.is-add .is-right {
  background: #ecf8f3;
}
.ops-diff-dialog .ops-diff-line.is-chg .is-right .ops-diff-text, .ops-diff-dialog .ops-diff-line.is-add .is-right .ops-diff-text {
  color: #1f6b53;
}
.ops-diff-dialog .ops-diff-line.is-chg .is-right .ops-diff-hl, .ops-diff-dialog .ops-diff-line.is-add .is-right .ops-diff-hl {
  background: #b5e8d2;
}
.ops-diff-dialog .ops-diff-line.is-del .is-right, .ops-diff-dialog .ops-diff-line.is-add .is-left {
  background: repeating-linear-gradient(135deg, #f6f7f9 0 6px, #eef0f3 6px 12px);
}
.ops-diff-dialog .ops-diff-stat {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.ops-diff-dialog .ops-diff-stat .is-add {
  color: #1f7a5e;
}
.ops-diff-dialog .ops-diff-stat .is-del {
  color: #c8394f;
}
.ops-diff-dialog .ops-diff-stat .is-chg {
  color: #8a6a16;
}
.ops-diff-dialog .ops-diff-nav {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 2px;
  border-radius: 16px;
  border: 1px solid var(--border-weak-color);
}
.ops-diff-dialog .ops-diff-nav .ops-diff-nav-btn {
  width: 26px;
  height: 26px;
  min-height: 26px;
  padding: 0;
  border: none;
  border-radius: 13px;
  background: transparent;
  color: var(--dark-color-main);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ops-diff-dialog .ops-diff-nav .ops-diff-nav-btn .bi {
  font-size: 13px;
}
.ops-diff-dialog .ops-diff-nav .ops-diff-nav-btn:hover {
  background: var(--ops-seg-bg);
  color: var(--dark-color-dark);
}
.ops-diff-dialog .ops-diff-nav .ops-diff-nav-label {
  min-width: 72px;
  text-align: center;
  white-space: nowrap;
  font-size: 12px;
  color: var(--dark-color-dark);
  font-variant-numeric: tabular-nums;
}
.ops-diff-dialog .ops-diff-mode-count {
  min-width: 16px;
  height: 16px;
  padding: 0 5px;
  border-radius: 8px;
  box-sizing: border-box;
  font-size: 10px;
  font-weight: 700;
  line-height: 16px;
  text-align: center;
  background: var(--primary-color-main);
  color: var(--white-color-lightest);
}
.ops-diff-dialog .ops-save-message {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 24px;
  border-bottom: 1px solid var(--ops-line);
  flex-shrink: 0;
}
.ops-diff-dialog .ops-save-message .ops-save-message-label {
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 1px;
}
.ops-diff-dialog .ops-save-message .ops-save-message-input {
  min-height: 0;
  max-height: 30vh;
}
.ops-diff-dialog .ops-diff-apply-note {
  flex: 1 1;
  min-width: 240px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: var(--ops-draft-fg);
}
.ops-diff-dialog .ops-diff-apply-note .bi {
  font-size: 14px;
}

.ops-scope .ops-auto-list {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.ops-scope .ops-auto-item {
  display: flex;
  align-items: baseline;
  gap: 8px;
  padding: 4px 8px;
  border-radius: 6px;
  background: var(--white-color-light);
  font-size: 12px;
  min-width: 0;
}
.ops-scope .ops-auto-label {
  flex-shrink: 0;
  font-weight: 600;
  color: var(--dark-color-dark);
}
.ops-scope .ops-auto-example {
  min-width: 0;
  font-size: 11px;
  color: var(--font_active_sub_color);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ops-scope .ops-ver-tag {
  display: inline-flex;
  align-items: center;
  padding: 0 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  line-height: 18px;
  flex-shrink: 0;
  white-space: nowrap;
  cursor: default;
}
.ops-scope .ops-ver-tag.is-deployed {
  background: var(--primary-color-lightest);
  color: var(--primary-color-dark);
}
.ops-scope .ops-ver-tag.is-draft {
  background: var(--ops-draft-bg);
  color: #7a5c0f;
}
.ops-scope .ops-form-card {
  background: var(--white-color-lightest);
  border-radius: 8px;
  padding: 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ops-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ops-help-button {
  width: 24px;
  height: 24px;
  min-height: 24px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: var(--font_active_sub_color);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.ops-help-button .bi {
  font-size: 18px;
  line-height: 1;
}
.ops-help-button:hover {
  color: var(--primary-color-main);
  background: var(--primary-color-lightest);
}

.ops-help-dialog .ops-help {
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-size: 13px;
  line-height: 1.7;
  color: var(--dark-color-dark);
}
.ops-help-dialog .ops-help code, .ops-help-dialog .ops-help kbd {
  font-family: var(--ops-mono);
}
.ops-help-dialog .ops-help-tabs {
  display: flex;
  gap: 4px;
  padding: 4px;
  border-radius: 10px;
  background: var(--input-bg-color);
  border: 1px solid var(--ops-line);
}
.ops-help-dialog .ops-help-tab {
  flex: 1 1;
  min-height: 36px;
  border: none;
  border-radius: 7px;
  background: transparent;
  color: var(--font_active_sub_color);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.ops-help-dialog .ops-help-tab .bi {
  font-size: 15px;
}
.ops-help-dialog .ops-help-tab:hover {
  color: var(--dark-color-dark);
}
.ops-help-dialog .ops-help-tab.is-active {
  background: var(--white-color-lightest);
  color: var(--primary-color-main);
  box-shadow: 0 1px 3px rgba(46, 50, 66, 0.15);
}
.ops-help-dialog .ops-help-panel {
  min-height: 340px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.ops-help-dialog .ops-help-steps {
  display: flex;
  align-items: stretch;
  gap: 8px;
}
.ops-help-dialog .ops-help-step {
  position: relative;
  flex: 1 1;
  padding: 20px 16px;
  border-radius: 12px;
  background: var(--white-color-light);
  border: 1px solid var(--ops-line);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.ops-help-dialog .ops-help-step-num {
  position: absolute;
  top: 10px;
  left: 14px;
  font-size: 20px;
  font-weight: 800;
  line-height: 1;
  color: var(--primary-color-main);
  font-family: var(--ops-mono);
}
.ops-help-dialog .ops-help-step-icon {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: var(--primary-color-lightest);
  color: var(--primary-color-main);
  display: flex;
  align-items: center;
  justify-content: center;
}
.ops-help-dialog .ops-help-step-icon .bi {
  font-size: 24px;
}
.ops-help-dialog .ops-help-step-title {
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 1px;
}
.ops-help-dialog .ops-help-step-text {
  font-size: 12px;
  color: var(--font_active_sub_color);
  line-height: 1.6;
}
.ops-help-dialog .ops-help-step-arrow {
  align-self: center;
  color: var(--border-color);
  font-size: 18px;
}
.ops-help-dialog .ops-help-callout {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  padding: 12px 14px;
  border-radius: 10px;
}
.ops-help-dialog .ops-help-callout > .bi {
  font-size: 16px;
  margin-top: 2px;
}
.ops-help-dialog .ops-help-callout.is-warn {
  background: var(--white-color-light);
  border: 1px solid var(--ops-warn-border);
  color: var(--ops-warn-text);
}
.ops-help-dialog .ops-help-callout .ops-help-severity {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 6px 10px;
  margin-top: 8px;
}
.ops-help-dialog .ops-help-callout .ops-help-sev-item {
  display: contents;
}
.ops-help-dialog .ops-help-callout .ops-help-sev {
  justify-self: start;
}
.ops-help-dialog .ops-help-legend {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
.ops-help-dialog .ops-help-legend-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 10px;
  background: var(--white-color-light);
  border: 1px solid var(--ops-line);
  font-size: 12px;
  color: var(--font_active_sub_color);
}
.ops-help-dialog .ops-help-legend-item b {
  color: var(--dark-color-dark);
}
.ops-help-dialog .ops-help-legend-visual {
  width: 84px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
}
.ops-help-dialog .ops-help-band {
  display: block;
  width: 60px;
  height: 22px;
  border-radius: 3px;
  background: color-mix(in srgb, var(--primary-color-main) 6%, var(--white-color-lightest));
  box-shadow: inset 3px 0 0 var(--primary-color-main);
}
.ops-help-dialog .ops-help-star {
  color: #e0a400;
  font-size: 16px;
}
.ops-help-dialog .ops-help-pencil {
  color: var(--input-placeholder-color);
  font-size: 14px;
}
.ops-help-dialog .ops-help-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 24px;
  padding: 0 8px;
  border-radius: 6px;
  border: 1px solid var(--border-color);
  background: var(--white-color-lightest);
  font-size: 11px;
  white-space: nowrap;
  color: var(--dark-color-dark);
}
.ops-help-dialog .ops-help-severity {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 18px;
  font-size: 12px;
  color: var(--font_active_sub_color);
}
.ops-help-dialog .ops-help-sev-item {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}
.ops-help-dialog .ops-help-sev {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0 8px;
  border-radius: 10px;
  font-weight: 700;
  line-height: 22px;
}
.ops-help-dialog .ops-help-sev.is-error {
  color: var(--ops-error-text);
  background: var(--ops-error-bg);
}
.ops-help-dialog .ops-help-sev.is-warn {
  color: var(--ops-warn-text);
  background: var(--ops-warn-bg);
}
.ops-help-dialog .ops-help-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
.ops-help-dialog .ops-help-card {
  padding: 14px;
  border-radius: 10px;
  background: var(--white-color-light);
  border: 1px solid var(--ops-line);
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.ops-help-dialog .ops-help-card.is-wide {
  grid-column: 1/-1;
}
.ops-help-dialog .ops-help-card-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 800;
}
.ops-help-dialog .ops-help-card-title .bi {
  color: var(--primary-color-main);
  font-size: 16px;
}
.ops-help-dialog .ops-help-card-text {
  font-size: 12px;
  color: var(--font_active_sub_color);
}
.ops-help-dialog .ops-help-examples {
  display: flex;
  align-items: center;
  gap: 8px;
}
.ops-help-dialog .ops-help-example-arrow {
  color: var(--border-color);
}
.ops-help-dialog .ops-help-example {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  align-self: flex-start;
  padding: 3px 10px 3px 8px;
  border-radius: 6px;
  font-size: 12px;
}
.ops-help-dialog .ops-help-example code {
  font-size: 12px;
}
.ops-help-dialog .ops-help-example.is-good {
  background: #e8f6f1;
  color: #1f7a5e;
}
.ops-help-dialog .ops-help-example.is-bad {
  background: var(--ops-error-bg);
  color: var(--ops-error-text);
}
.ops-help-dialog .ops-help-vars {
  margin-top: 6px;
  padding-top: 10px;
  border-top: 1px dashed var(--ops-line);
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.ops-help-dialog .ops-help-vars-label {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 1px;
  color: var(--font_active_sub_color);
}
.ops-help-dialog .ops-help-vars-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  font-size: 12px;
}
.ops-help-dialog .ops-help-vars-row code {
  padding: 0 6px;
  border-radius: 4px;
  background: var(--white-color-lightest);
  border: 1px solid var(--ops-line);
  font-size: 11.5px;
}
.ops-help-dialog .ops-help-vars-tab {
  min-width: 150px;
  color: var(--font_active_sub_color);
}
.ops-help-dialog .ops-help-vars-none {
  color: var(--font_active_sub_color);
}
.ops-help-dialog .ops-help-more {
  align-self: flex-start;
  border: none;
  background: transparent;
  padding: 0;
  color: #1F5FAF;
  font-size: 12px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.ops-help-dialog .ops-help-keys {
  display: flex;
  flex-direction: column;
}
.ops-help-dialog .ops-help-lead {
  margin-bottom: 4px;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 1px;
  color: var(--font_active_sub_color);
}
.ops-help-dialog .ops-help-key-row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 10px 4px;
  border-bottom: 1px solid var(--ops-line);
}
.ops-help-dialog .ops-help-key-caps {
  width: 200px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 4px;
}
.ops-help-dialog .ops-help-key-caps kbd {
  min-width: 28px;
  padding: 3px 8px;
  border-radius: 6px;
  border: 1px solid var(--border-color);
  border-bottom-width: 3px;
  background: var(--white-color-lightest);
  font-size: 12px;
  text-align: center;
}
.ops-help-dialog .ops-help-key-plus {
  color: var(--font_active_sub_color);
  font-size: 11px;
}
.ops-help-dialog .ops-help-key-text {
  font-size: 13px;
}`, "",{"version":3,"sources":["webpack://./src/components/admin/parts/ops/AdminOpsPrompt.scss"],"names":[],"mappings":"AACA;EACI,2BAAA;AAAJ;AAEI;EACI,WAAA;EACA,+CAAA;EACA,sBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;AAAR;AAGI;EACI,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AADR;AAOI;EACI,cAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;EAEA,gCAAA;AANR;AAQQ;EACI,wBAAA;AANZ;AASQ;EACI,YAAA;AAPZ;AASY;EACI,UAAA;EACA,oBAAA;AAPhB;AASY;EACI,uBAAA;AAPhB;AASY;EACI,aAAA;EACA,UAAA;EACA,cAAA;EACA,iBAAA;AAPhB;AASY;EACI,YAAA;EACA,aAAA;AAPhB;AAYI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,iDAAA;AAVR;AAaI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,uBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,6BAAA;EACA,gBAAA;AAXR;AAaQ;EACI,eAAA;EACA,0BAAA;EACA,yBAAA;AAXZ;AAaQ;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;AAXZ;AAeI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,sBAAA;EACA,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,mEAAA;EACA,iDAAA;AAbR;AAeQ;EACI,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mCAAA;EACA,mBAAA;AAbZ;AAiBI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,uCAAA;EACA,iCAAA;AAfR;AAiBQ;EACI,iDAAA;AAfZ;AAkBQ;EACI,eAAA;EACA,4BAAA;EACA,mBAAA;EACA,mCAAA;AAhBZ;AAkBQ;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,qCAAA;AAhBZ;AAmBQ;EACI,yCAAA;EACA,uCAAA;AAjBZ;AAmBY;EACI,gCAAA;EACA,gBAAA;AAjBhB;AAsBI;EACI,SAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AApBR;AAuBI;EACI,aAAA;EACA,eAAA;EACA,qCAAA;AArBR;AAwBI;EACI,aAAA;EACA,oBAAA;EACA,yCAAA;EACA,gBAAA;EACA,sBAAA;EAEA,YAAA;EACA,gBAAA;EACA,2EAAA;AAvBR;AA0BQ;EACI,yFAAA;EACA,mDAAA;AAxBZ;AA6BI;EACI,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AA3BR;AA6BQ;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,+BAAA;AA3BZ;AA+BI;EACI,cAAA;EACA,iBAAA;AA7BR;AA+BQ;EACI,UAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;AA7BZ;AA+BY;EACI,iCAAA;EACA,eAAA;AA7BhB;AA+BY;EACI,qBAAA;AA7BhB;AAiCQ;EACI,iCAAA;EACA,uCAAA;EACA,iBAAA;AA/BZ;AAiCY;EACI,iCAAA;AA/BhB;AAiCY;EACI,+BAAA;EACA,iCAAA;AA/BhB;AAiCY;EACI,iCAAA;EACA,iCAAA;EACA,uBAAA;AA/BhB;AAoCI;EACI,SAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,uBAAA;EACA,sBAAA;AAlCR;AAqCI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;AAnCR;AAqCQ;EACI,eAAA;EACA,iBAAA;EACA,4BAAA;EACA,cAAA;EACA,gBAAA;AAnCZ;AAqCQ;EACI,SAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAnCZ;AAqCQ;EACI,YAAA;EACA,eAAA;EACA,4BAAA;EACA,iCAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAnCZ;AAuCI;EACI,gCAAA;EACA,gBAAA;AArCR;AAyCI;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qCAAA;AAvCR;AAyCQ;EAAM,eAAA;EAAiB,iBAAA;AArC/B;AAuCQ;EAEI,cAAA;AAtCZ;AAwCQ;EACI,+BAAA;AAtCZ;AA0CI;EACI,SAAA;EACA,cAAA;AAxCR;AA2CI;EACI,aAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;AAzCR;AA4CQ;EACI,YAAA;EACA,eAAA;EACA,6BAAA;EACA,iBAAA;EACA,qBAAA;EACA,uBAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;AA1CZ;AA4CY;EAAgB,YAAA;AAzC5B;AA8CI;;EAEI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qCAAA;AA5CR;AA8CQ;;EAAM,eAAA;EAAiB,iBAAA;AAzC/B;AA2CQ;;EACI,6BAAA;EACA,iDAAA;AAxCZ;AA0CQ;;EACI,YAAA;EACA,eAAA;EACA,uBAAA;AAvCZ;AA0CI;EACI,gCAAA;AAxCR;AA0CI;EACI,SAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,QAAA;AAxCR;AA2CI;EACI,SAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;EACA,qCAAA;EACA,kBAAA;EACA,uCAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;AAzCR;AA2CQ;EAAU,uCAAA;AAxClB;AAyCQ;EAAa,8BAAA;AAtCrB;AAuCQ;EAAa,YAAA;AApCrB;AAwCI;EACI,aAAA;EACA,QAAA;EACA,eAAA;AAtCR;AA0CI;EACI,YAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,sBAAA;EACA,4CAAA;EACA,qCAAA;EACA,uCAAA;EACA,6BAAA;EACA,eAAA;EACA,mBAAA;AAxCR;AA0CQ;EAAM,eAAA;AAvCd;AAyCQ;EACI,mBAAA;EACA,qBAAA;AAvCZ;AA0CQ;EACI,qCAAA;EACA,6BAAA;EACA,gBAAA;EACA,mBAAA;AAxCZ;AA0CY;EACI,uCAAA;EACA,6BAAA;AAxChB;AA4CQ;EACI,uCAAA;EACA,gCAAA;AA1CZ;AA4CY;EACI,qCAAA;EACA,uCAAA;EACA,kCAAA;AA1ChB;AAkDI;EACI,SAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;AAhDR;AAmDI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,iDAAA;EACA,eAAA;EACA,YAAA;AAjDR;AAqDI;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AAnDR;AAqDI;EACI,6CAAA;EACA,gBAAA;EACA,cAAA;AAnDR;AAqDI;EACI,8CAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAnDR;AAqDQ;EACI,kBAAA;EACA,eAAA;AAnDZ;AAwDI;EACI,kBAAA;EACA,aAAA;EACA,YAAA;EACA,QAAA;EACA,mBAAA;EACA,6BAAA;EACA,sBAAA;AAtDR;AAwDI;EACI,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,cAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,6CAAA;EACA,uBAAA;EACA,6BAAA;AAtDR;AAwDQ;EACI,uCAAA;EACA,6BAAA;EACA,gBAAA;EACA,4CAAA;AAtDZ;AAyDI;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,qCAAA;EACA,cAAA;AAvDR;AA0DI;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;AAxDR;AA0DQ;EACI,kBAAA;EACA,WAAA;EACA,eAAA;EACA,6BAAA;EACA,oBAAA;AAxDZ;AA2DQ;EACI,kBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,qCAAA;EACA,oBAAA;AAzDZ;AA4DQ;EACI,kBAAA;AA1DZ;AA8DI;EACI,gBAAA;EACA,wBAAA;EACA,YAAA;EACA,sBAAA;EACA,sBAAA;EACA,0CAAA;EACA,mBAAA;EACA,uCAAA;EACA,6BAAA;EACA,oBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AA5DR;AA8DQ;EACI,gBAAA;AA5DZ;AAgEI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AA9DR;AAiEI;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,0BAAA;EACA,mBAAA;AA/DR;AAiEI;;EAEI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,qCAAA;EACA,cAAA;AA/DR;AAkEI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iDAAA;EACA,oCAAA;EACA,eAAA;EACA,YAAA;AAhER;AAmEI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAjER;AAoEI;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,6BAAA;EACA,gCAAA;EACA,oBAAA;AAlER;AAoEQ;EAAM,eAAA;AAjEd;AAmEQ;EACI,iDAAA;AAjEZ;AAoEQ;EACI,2DAAA;EACA,wCAAA;EACA,gCAAA;AAlEZ;AAuEI;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,cAAA;EACA,mCAAA;EACA,mBAAA;AArER;AAuEQ;EAAM,eAAA;AApEd;AAuEI;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AArER;AAuEQ;EAAM,eAAA;AApEd;AAsEQ;EAAa,uBAAA;AAnErB;AAoEQ;EACI,2BAAA;AAlEZ;AAmEY;EAAM,sBAAA;AAhElB;AAoEI;EACI,eAAA;EACA,0BAAA;AAlER;AAoEQ;EAAY,0BAAA;AAjEpB;AAoEI;EACI,eAAA;EACA,mCAAA;AAlER;AAsEI;EACI,SAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;AApER;AAuEI;EACI,YAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AArER;AAuEQ;EACI,4EAAA;AArEZ;AAuEQ;EACI,gDAAA;EACA,8CAAA;EACA,gBAAA;AArEZ;AAyEI;EACI,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,sBAAA;EACA,sBAAA;EACA,oCAAA;EACA,wCAAA;EACA,gBAAA;EACA,YAAA;EACA,kCAAA;AAvER;AAyEI;EACI,yCAAA;AAvER;AAyEQ;EAAkB,gCAAA;AAtE1B;AAyEI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;AAvER;AA0EI;EACI,eAAA;AAxER;AA2EI;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,0CAAA;EACA,uCAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;AAzER;AA2EQ;EAAM,eAAA;EAAiB,cAAA;AAvE/B;AAyEQ;EAAU,oCAAA;AAtElB;AAwEQ;EACI,yCAAA;EACA,gCAAA;EACA,uCAAA;AAtEZ;AA0EI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AAxER;AA2EI;EACI,YAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,uCAAA;EACA,0CAAA;EACA,6BAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAzER;AA2EQ;EAAM,eAAA;EAAiB,cAAA;AAvE/B;AAyEQ;EACI,kCAAA;EACA,cAAA;EACA,oCAAA;AAvEZ;AA2EI;EACI,SAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;AAzER;AA6EI;EACI,kBAAA;EACA,cAAA;EACA,6CAAA;EACA,0DAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;AA3ER;AA6EQ;EACI,UAAA;EACA,YAAA;EACA,oCAAA;EACA,kCAAA;AA3EZ;AA6EQ;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uCAAA;EACA,0CAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,4CAAA;AA3EZ;AA6EY;EAAM,eAAA;EAAiB,cAAA;AAzEnC;AA4EY;EACI,UAAA;EACA,qCAAA;AA1EhB;AA4EY;EACI,uCAAA;EACA,gCAAA;AA1EhB;AA+EI;EACI,YAAA;EACA,cAAA;EACA,uCAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,+BAAA;AA7ER;AA+EQ;EACI,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,mCAAA;EACA,mBAAA;AA7EZ;AA+EQ;EACI,eAAA;EACA,qCAAA;EACA,eAAA;AA7EZ;AAiFI;EACI,aAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,6BAAA;AA/ER;AAiFQ;EACI,iDAAA;AA/EZ;AAkFQ;EACI,cAAA;EACA,iBAAA;EACA,YAAA;EACA,qCAAA;EACA,cAAA;EACA,4BAAA;AAhFZ;AAkFQ;EACI,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AAhFZ;AAkFQ;EACI,YAAA;EACA,eAAA;EACA,sBAAA;AAhFZ;AAmFQ;EACI,yCAAA;EACA,gCAAA;EACA,gBAAA;AAjFZ;AAqFI;EACI,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,uBAAA;AAnFR;AAqFQ;EACI,sBAAA;AAnFZ;AAuFI;EACI,YAAA;EACA,aAAA;EACA,oBAAA;AArFR;AAuFQ;EACI,UAAA;EACA,cAAA;AArFZ;AAuFY;EAAa,qCAAA;AApFzB;AAqFY;EAAe,qCAAA;AAlF3B;AAmFY;EAAe,oCAAA;AAhF3B;AAkFQ;EACI,SAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BAAA;EACA,iBAAA;EACA,qCAAA;AAhFZ;AAmFQ;EACI,+BAAA;AAjFZ;AAkFY;EAAkB,4BAAA;AA/E9B;AAiFQ;EACI,8BAAA;AA/EZ;AAgFY;EAAkB,2BAAA;AA7E9B;AAiFI;EACI,SAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AA/ER;AAkFI;EACI,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,oBAAA;AAhFR;AAkFQ;EACI,kBAAA;EACA,sBAAA;AAhFZ;AAoFI;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,sBAAA;AAlFR;AAoFQ;EACI,kBAAA;EACA,WAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AAlFZ;AAoFY;EAAM,eAAA;AAjFlB;AAoFQ;EACI,+BAAA;EACA,iDAAA;AAlFZ;AAmFY;EAAgB,4BAAA;AAhF5B;AAiFY;EAAM,uBAAA;AA9ElB;AAgFQ;EACI,8BAAA;EACA,gDAAA;AA9EZ;AA+EY;EAAgB,2BAAA;AA5E5B;AA6EY;EAAM,sBAAA;AA1ElB;AA8EI;EACI,SAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;AA5ER;AA8EQ;EACI,6BAAA;AA5EZ;AAiFI;EACI,kBAAA;EACA,oBAAA;EACA,gBAAA;AA/ER;AAkFI;EACI,YAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,0CAAA;EACA,gCAAA;EACA,2BAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AAhFR;AAkFQ;EAAM,eAAA;AA/Ed;AAiFQ;EAEI,kCAAA;AAhFZ;AAoFI;EACI,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,0CAAA;EACA,uCAAA;EACA,6CAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAlFR;AAqFI;EACI,eAAA;EACA,gBAAA;EACA,6BAAA;AAnFR;AAuFI;EACI,kBAAA;EACA,oBAAA;AArFR;AAwFI;EACI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,0CAAA;EACA,uCAAA;EACA,6CAAA;EACA,gBAAA;AAtFR;AAyFI;EACI,SAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;AAvFR;AA0FI;EACI,iBAAA;EACA,kBAAA;EACA,eAAA;AAxFR;AA0FQ;EACI,yCAAA;AAxFZ;AA4FI;EACI,aAAA;EACA,qBAAA;EACA,QAAA;EACA,YAAA;AA1FR;AA4FQ;EACI,cAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;EACA,6BAAA;AA1FZ;AA8FI;EACI,gCAAA;AA5FR;AA+FI;EACI,YAAA;EACA,eAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA7FR;AAgGI;EACI,eAAA;EACA,eAAA;EACA,mCAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA9FR;AAiGI;EACI,cAAA;EACA,iBAAA;EACA,qCAAA;EACA,oCAAA;EACA,iBAAA;EACA,mCAAA;AA/FR;;AAwGI;EACI,YAAA;EACA,gBAAA;AArGR;AAyGI;EACI,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AAvGR;AA0GI;EACI,iBAAA;EACA,mCAAA;AAxGR;AA2GI;EACI,UAAA;EACA,uCAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAzGR;AA4GI;EACI,aAAA;EACA,YAAA;EACA,QAAA;EACA,mBAAA;EACA,6BAAA;EACA,sBAAA;AA1GR;AA6GI;EACI,YAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,cAAA;EACA,6CAAA;EACA,uBAAA;EACA,6BAAA;AA3GR;AA6GQ;EACI,uCAAA;EACA,6BAAA;EACA,gBAAA;EACA,4CAAA;AA3GZ;AAgHI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;AA9GR;AAgHQ;EAAM,eAAA;EAAiB,cAAA;EAAgB,cAAA;AA3G/C;AA6GI;EACI,eAAA;EACA,gBAAA;EACA,6BAAA;AA3GR;AA6GI;EACI,eAAA;EACA,6BAAA;AA3GR;AA6GI;EACI,eAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,0CAAA;EACA,uCAAA;EACA,6BAAA;EACA,oBAAA;EACA,eAAA;EACA,eAAA;AA3GR;AA6GQ;EAAU,iDAAA;AA1GlB;AA6GI;EACI,aAAA;EACA,wCAAA;EACA,oCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;EACA,cAAA;AA3GR;AA6GQ;EACI,SAAA;EACA,iBAAA;AA3GZ;AA6GY;EAAgB,uCAAA;AA1G5B;AA8GI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,oCAAA;EACA,wCAAA;EACA,eAAA;EACA,6BAAA;EACA,cAAA;AA5GR;AA+GI;EACI,SAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,uCAAA;AA7GR;AAiHI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,cAAA;EACA,YAAA;EACA,qCAAA;EACA,wCAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,6BAAA;EACA,eAAA;AA/GR;AAiHQ;EAAM,eAAA;AA9Gd;AA+GQ;EAAU,mBAAA;EAAqB,6BAAA;AA3GvC;AA8GI;EACI,aAAA;EACA,oBAAA;EACA,kBAAA;AA5GR;AA+GQ;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,kCAAA;EACA,UAAA;AA7GZ;AA+GQ;EACI,SAAA;EACA,YAAA;EACA,aAAA;AA7GZ;AA+GY;EAAY,uCAAA;AA5GxB;AA8GQ;EACI,WAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,4BAAA;EACA,cAAA;EACA,yBAAA;UAAA,iBAAA;EACA,sBAAA;AA5GZ;AA8GQ;EACI,WAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,4BAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;AA5GZ;AA8GQ;EAA0B,cAAA;AA3GlC;AA4GQ;EAA2B,cAAA;AAzGnC;AA0GQ;EACI,SAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;AAxGZ;AA0GQ;EAAe,kBAAA;AAvGvB;AA0GY;EAA0B,6BAAA;AAvGtC;AAwGY;EAA2B,6BAAA;AArGvC;AAwGY;EAAW,mBAAA;AArGvB;AAqG4C;EAAiB,cAAA;AAlG7D;AAkG+E;EAAe,mBAAA;AA/F9F;AAkGY;EAAY,mBAAA;AA/FxB;AA+F6C;EAAiB,cAAA;AA5F9D;AA4FgF;EAAe,mBAAA;AAzF/F;AA4FQ;EACI,8EAAA;AA1FZ;AA+FI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,mBAAA;AA7FR;AA+FQ;EAAU,cAAA;AA5FlB;AA6FQ;EAAU,cAAA;AA1FlB;AA2FQ;EAAU,cAAA;AAxFlB;AA4FI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,0CAAA;AA1FR;AA4FQ;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA1FZ;AA4FY;EAAM,eAAA;AAzFlB;AA0FY;EAAU,6BAAA;EAA+B,6BAAA;AAtFrD;AAwFQ;EACI,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,6BAAA;EACA,kCAAA;AAtFZ;AA0FI;EACI,eAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qCAAA;EACA,kCAAA;AAxFR;AA4FI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,wCAAA;EACA,cAAA;AA1FR;AA4FQ;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AA1FZ;AA4FQ;EACI,aAAA;EACA,gBAAA;AA1FZ;AA8FI;EACI,SAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,0BAAA;AA5FR;AA8FQ;EAAM,eAAA;AA3Fd;;AAkGI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AA/FR;AAiGI;EACI,aAAA;EACA,qBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,oCAAA;EACA,eAAA;EACA,YAAA;AA/FR;AAiGI;EACI,cAAA;EACA,gBAAA;EACA,6BAAA;AA/FR;AAiGI;EACI,YAAA;EACA,eAAA;EACA,mCAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA/FR;AAmGI;EACI,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;AAjGR;AAmGQ;EACI,yCAAA;EACA,gCAAA;AAjGZ;AAmGQ;EACI,+BAAA;EACA,cAAA;AAjGZ;AAqGI;EACI,uCAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAnGR;;AAwGA;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AArGJ;;AAwGA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,mCAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AArGJ;AAuGI;EAAM,eAAA;EAAiB,cAAA;AAnG3B;AAqGI;EACI,gCAAA;EACA,yCAAA;AAnGR;;AAyGI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;AAtGR;AAwGQ;EACI,4BAAA;AAtGZ;AA2GI;EACI,aAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,iCAAA;EACA,iCAAA;AAzGR;AA2GI;EACI,SAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AAzGR;AA2GQ;EAAM,eAAA;AAxGd;AA0GQ;EAAU,6BAAA;AAvGlB;AAwGQ;EACI,uCAAA;EACA,gCAAA;EACA,4CAAA;AAtGZ;AAyGI;EACI,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAvGR;AA2GI;EACI,aAAA;EACA,oBAAA;EACA,QAAA;AAzGR;AA2GI;EACI,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,oCAAA;EACA,iCAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AAzGR;AA4GI;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gCAAA;EACA,4BAAA;AA1GR;AA4GI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yCAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA1GR;AA4GQ;EAAM,eAAA;AAzGd;AA2GI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AAzGR;AA2GI;EACI,eAAA;EACA,mCAAA;EACA,gBAAA;AAzGR;AA2GI;EACI,kBAAA;EACA,0BAAA;EACA,eAAA;AAzGR;AA4GI;EACI,aAAA;EACA,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;AA1GR;AA4GQ;EAAQ,eAAA;EAAiB,eAAA;AAxGjC;AA2GQ;EACI,oCAAA;EACA,wCAAA;EACA,2BAAA;AAzGZ;AA6GQ;EACI,aAAA;EACA,+BAAA;EACA,aAAA;EACA,eAAA;AA3GZ;AA6GQ;EAAqB,iBAAA;AA1G7B;AA2GQ;EAAgB,mBAAA;AAxGxB;AA4GI;EACI,aAAA;EACA,8BAAA;EACA,SAAA;AA1GR;AA4GI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,oCAAA;EACA,iCAAA;EACA,eAAA;EACA,mCAAA;AA1GR;AA4GQ;EAAI,6BAAA;AAzGZ;AA2GI;EACI,WAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;AAzGR;AA2GI;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yFAAA;EACA,mDAAA;AAzGR;AA2GI;EACI,cAAA;EACA,eAAA;AAzGR;AA2GI;EACI,qCAAA;EACA,eAAA;AAzGR;AA2GI;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,qCAAA;EACA,uCAAA;EACA,eAAA;EACA,mBAAA;EACA,6BAAA;AAzGR;AA6GI;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,mCAAA;AA3GR;AA8GI;EACI,oBAAA;EACA,mBAAA;EACA,SAAA;AA5GR;AA8GI;EACI,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AA5GR;AA8GQ;EAAa,4BAAA;EAA8B,+BAAA;AA1GnD;AA2GQ;EAAY,2BAAA;EAA6B,8BAAA;AAvGjD;AAyGI;EACI,aAAA;EACA,8BAAA;EACA,SAAA;AAvGR;AAyGI;EACI,aAAA;EACA,mBAAA;EACA,oCAAA;EACA,iCAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAvGR;AAyGQ;EAAY,iBAAA;AAtGpB;AAwGI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;AAtGR;AAwGQ;EAAM,gCAAA;EAAkC,eAAA;AApGhD;AAsGI;EACI,eAAA;EACA,mCAAA;AApGR;AAsGI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AApGR;AAsGI;EACI,0BAAA;AApGR;AAsGI;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AApGR;AAsGQ;EAAO,eAAA;AAnGf;AAoGQ;EAAY,mBAAA;EAAqB,cAAA;AAhGzC;AAiGQ;EAAW,+BAAA;EAAiC,4BAAA;AA7FpD;AA+FI;EACI,eAAA;EACA,iBAAA;EACA,sCAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA7FR;AA+FI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,mCAAA;AA7FR;AA+FI;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AA7FR;AA+FQ;EACI,cAAA;EACA,kBAAA;EACA,uCAAA;EACA,iCAAA;EACA,iBAAA;AA7FZ;AAgGI;EACI,gBAAA;EACA,mCAAA;AA9FR;AAgGI;EACI,mCAAA;AA9FR;AAgGI;EACI,sBAAA;EACA,YAAA;EACA,uBAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;AA9FR;AAkGI;EACI,aAAA;EACA,sBAAA;AAhGR;AAkGI;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,mCAAA;AAhGR;AAkGI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,wCAAA;AAhGR;AAkGI;EACI,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAhGR;AAkGQ;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,qCAAA;EACA,wBAAA;EACA,uCAAA;EACA,eAAA;EACA,kBAAA;AAhGZ;AAmGI;EACI,mCAAA;EACA,eAAA;AAjGR;AAmGI;EACI,eAAA;AAjGR","sourcesContent":["// プロンプト管理（デザイン PRizmo_Admin.dc.html L2178-2389）\n#AdminOpsPrompt {\n    justify-content: flex-start;\n\n    .ops-prompt-body {\n        width: 100%;\n        height: calc(100vh - var(--page-header-height));\n        box-sizing: border-box;\n        padding: 0 16px 16px;\n        display: flex;\n        flex-direction: row;\n        gap: 16px;\n        min-height: 0;\n    }\n\n    .ops-prompt-loading {\n        flex: 1;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    // ------------------------------------------------------------------\n    // 左: バージョン履歴\n    // ------------------------------------------------------------------\n    .ops-ver-panel {\n        flex-shrink: 0;\n        width: 340px;\n        display: flex;\n        flex-direction: column;\n        background: var(--white-color-lightest);\n        border-radius: 8px;\n        overflow: hidden;\n        transition: width .2s ease;\n        // 行高 auto ⇔ 34px の開閉もアニメーションさせる\n        interpolate-size: allow-keywords;\n\n        .ops-ver-fade {\n            transition: opacity .2s;\n        }\n\n        &.is-collapsed {\n            width: 128px;\n\n            .ops-ver-fade {\n                opacity: 0;\n                pointer-events: none;\n            }\n            .ops-ver-caret {\n                transform: rotate(0deg);\n            }\n            .ops-ver-summary {\n                max-height: 0;\n                opacity: 0;\n                padding-top: 0;\n                padding-bottom: 0;\n            }\n            .ops-ver-row {\n                height: 34px;\n                min-height: 0;\n            }\n        }\n    }\n\n    .ops-ver-head {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 8px;\n        padding: 0 14px;\n        height: 51px;\n        min-height: 51px;\n        box-sizing: border-box;\n        border-bottom: 1px solid var(--border-weak-color);\n    }\n\n    .ops-ver-toggle {\n        display: flex;\n        align-items: center;\n        gap: 6px;\n        background: transparent;\n        border: none;\n        padding: 0;\n        cursor: pointer;\n        color: var(--dark-color-dark);\n        min-height: 28px;\n\n        .ops-ver-caret {\n            font-size: 16px;\n            transition: transform .2s;\n            transform: rotate(180deg);\n        }\n        .ops-ver-title {\n            font-size: 14px;\n            font-weight: 800;\n            letter-spacing: 1px;\n            white-space: nowrap;\n            line-height: 1;\n        }\n    }\n\n    .ops-ver-summary {\n        display: flex;\n        align-items: center;\n        gap: 6px;\n        flex-wrap: wrap;\n        row-gap: 4px;\n        padding: 7px 12px;\n        width: 340px;\n        box-sizing: border-box;\n        background: var(--ops-panel-bg);\n        overflow: hidden;\n        max-height: 80px;\n        transition: max-height .25s ease, opacity .2s, padding .25s ease;\n        border-bottom: 1px solid var(--border-weak-color);\n\n        .ops-ver-summary-label {\n            font-size: 9.5px;\n            font-weight: 800;\n            letter-spacing: 1px;\n            color: var(--font_active_sub_color);\n            white-space: nowrap;\n        }\n    }\n\n    .ops-ver-chip {\n        display: flex;\n        align-items: center;\n        gap: 4px;\n        border-radius: 10px;\n        cursor: pointer;\n        height: 20px;\n        padding: 0 8px;\n        flex-shrink: 0;\n        background: var(--white-color-lightest);\n        border: 1px solid var(--ops-line);\n\n        &:hover {\n            background: var(--dark-color-dark-transparent-10);\n        }\n\n        .ops-ver-chip-label {\n            font-size: 10px;\n            font-family: var(--ops-mono);\n            white-space: nowrap;\n            color: var(--font_active_sub_color);\n        }\n        .ops-ver-chip-dot {\n            width: 5px;\n            height: 5px;\n            border-radius: 50%;\n            background: var(--warning-color-main);\n        }\n\n        &.is-current {\n            background: var(--primary-color-lightest);\n            border-color: var(--primary-color-main);\n\n            .ops-ver-chip-label {\n                color: var(--primary-color-main);\n                font-weight: 700;\n            }\n        }\n    }\n\n    .ops-ver-list {\n        flex: 1;\n        min-height: 0;\n        overflow-y: auto;\n        overflow-x: hidden;\n        position: relative;\n    }\n\n    .ops-ver-empty {\n        padding: 16px;\n        font-size: 12px;\n        color: var(--input-placeholder-color);\n    }\n\n    .ops-ver-row {\n        display: flex;\n        align-items: stretch;\n        border-bottom: 1px dashed var(--ops-line);\n        overflow: hidden;\n        box-sizing: border-box;\n        // 最小は 上下余白14 + 1行目20 + 2行目18 + ボタン列28 + 行間6 + 図の余白6。メモが複数行なら伸びる\n        height: auto;\n        min-height: 92px;\n        transition: height .25s ease, min-height .25s ease, background-color .3s;\n\n        // エディタに表示している版（左端に色帯を立てる）\n        &.is-selected {\n            background: color-mix(in srgb, var(--primary-color-main) 6%, var(--white-color-lightest));\n            box-shadow: inset 3px 0 0 var(--primary-color-main);\n        }\n    }\n\n    // ブランチ図（表示幅を超えるレーンは横にずらして選択中のレーンを見せる）\n    .ops-ver-gutter {\n        flex-shrink: 0;\n        position: relative;\n        overflow: hidden;\n        margin-left: 10px;\n        margin-right: 6px;\n\n        .ops-ver-gutter-inner {\n            position: absolute;\n            top: 0;\n            bottom: 0;\n            left: 0;\n            transition: transform .3s ease;\n        }\n    }\n\n    .ops-ver-graph {\n        display: block;\n        overflow: visible;\n\n        path {\n            fill: none;\n            stroke: #d0d5dd;\n            stroke-width: 1.5;\n            stroke-linecap: round;\n\n            &.is-hl {\n                stroke: var(--primary-color-main);\n                stroke-width: 2;\n            }\n            &.is-dashed {\n                stroke-dasharray: 3 3;\n            }\n        }\n\n        .ops-ver-graph-dot {\n            fill: var(--white-color-lightest);\n            stroke: var(--font_active_hidden_color);\n            stroke-width: 2.2;\n\n            &.is-lineage {\n                stroke: var(--primary-color-main);\n            }\n            &.is-filled {\n                fill: var(--primary-color-main);\n                stroke: var(--primary-color-main);\n            }\n            &.is-draft {\n                fill: var(--white-color-lightest);\n                stroke: var(--warning-color-main);\n                stroke-dasharray: 2.5 2;\n            }\n        }\n    }\n\n    .ops-ver-content {\n        flex: 1;\n        min-width: 0;\n        display: flex;\n        flex-direction: column;\n        gap: 3px;\n        padding: 7px 10px 7px 0;\n        box-sizing: border-box;\n    }\n\n    .ops-ver-line1 {\n        display: flex;\n        align-items: center;\n        gap: 6px;\n        min-width: 0;\n        height: 20px;\n\n        .ops-ver-label {\n            font-size: 12px;\n            line-height: 16px;\n            font-family: var(--ops-mono);\n            flex-shrink: 0;\n            font-weight: 600;\n        }\n        .ops-ver-meta {\n            flex: 1;\n            min-width: 0;\n            display: flex;\n            align-items: center;\n            gap: 6px;\n        }\n        .ops-ver-date {\n            min-width: 0;\n            font-size: 11px;\n            font-family: var(--ops-mono);\n            color: var(--disabled-font-color);\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n        }\n    }\n\n    .ops-ver-row.is-deployed .ops-ver-label {\n        color: var(--primary-color-main);\n        font-weight: 700;\n    }\n\n    // スター（良かった版の印）\n    .ops-ver-star {\n        width: 20px;\n        height: 20px;\n        min-height: 20px;\n        padding: 0;\n        border: none;\n        border-radius: 4px;\n        background: transparent;\n        cursor: pointer;\n        flex-shrink: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        color: var(--input-placeholder-color);\n\n        .bi { font-size: 14px; line-height: 14px; }\n\n        &:hover,\n        &.is-on {\n            color: #e0a400;\n        }\n        &:hover {\n            background: var(--ops-draft-bg);\n        }\n    }\n\n    .ops-ver-spacer {\n        flex: 1;\n        min-width: 4px;\n    }\n\n    .ops-ver-line2 {\n        display: flex;\n        align-items: flex-start;\n        gap: 4px;\n        min-width: 0;\n        min-height: 18px;\n\n        // 改行を反映して3行まで。はみ出しは三点リーダー\n        .ops-ver-message {\n            min-width: 0;\n            font-size: 12px;\n            color: var(--dark-color-main);\n            line-height: 18px;\n            white-space: pre-wrap;\n            overflow-wrap: anywhere;\n            display: -webkit-box;\n            -webkit-box-orient: vertical;\n            -webkit-line-clamp: 3;\n            overflow: hidden;\n\n            &.is-editable { cursor: text; }\n        }\n    }\n\n    // 変更メモの編集（鉛筆ボタンと、その場の入力欄）\n    .ops-ver-memo-edit,\n    .ops-ver-memo-btn {\n        width: 18px;\n        height: 18px;\n        min-height: 18px;\n        padding: 0;\n        border: none;\n        border-radius: 4px;\n        background: transparent;\n        cursor: pointer;\n        flex-shrink: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        color: var(--input-placeholder-color);\n\n        .bi { font-size: 12px; line-height: 12px; }\n\n        &:hover {\n            color: var(--dark-color-main);\n            background: var(--dark-color-dark-transparent-10);\n        }\n        &:disabled {\n            opacity: .4;\n            cursor: default;\n            background: transparent;\n        }\n    }\n    .ops-ver-memo-btn.is-ok:not(:disabled) {\n        color: var(--primary-color-main);\n    }\n    .ops-ver-memo-form {\n        flex: 1;\n        min-width: 0;\n        display: flex;\n        align-items: flex-start;\n        gap: 2px;\n    }\n    // 入力に合わせて伸び、3行を超えたらスクロール\n    .ops-ver-memo-input {\n        flex: 1;\n        min-width: 0;\n        field-sizing: content;\n        min-height: 20px;\n        max-height: 58px;\n        margin: -1px 2px -1px 0;\n        padding: 0 6px;\n        box-sizing: border-box;\n        border: 1px solid var(--border-color);\n        border-radius: 4px;\n        background: var(--white-color-lightest);\n        font-family: inherit;\n        font-size: 12px;\n        line-height: 18px;\n        color: var(--dark-color-main);\n        outline: none;\n        resize: none;\n        overflow-y: auto;\n\n        &:focus { border-color: var(--primary-color-main); }\n        &.is-error { border-color: var(--ops-error); }\n        &:disabled { opacity: .6; }\n    }\n\n\n    .ops-ver-actions {\n        display: flex;\n        gap: 6px;\n        margin-top: 2px;\n    }\n\n    // 版の操作ボタン（押せることが分かるよう枠・影・アイコン付きにする）\n    .ops-ver-action {\n        height: 26px;\n        min-height: 26px;\n        padding: 0 10px;\n        border-radius: 6px;\n        font-size: 12px;\n        line-height: 1;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 4px;\n        box-sizing: border-box;\n        box-shadow: 0 1px 2px rgba(46, 50, 66, .12);\n        border: 1px solid var(--border-color);\n        background: var(--white-color-lightest);\n        color: var(--dark-color-dark);\n        cursor: pointer;\n        white-space: nowrap;\n\n        .bi { font-size: 14px; }\n\n        &:hover {\n            background: #f1f2f4;\n            border-color: #9aa1ae;\n        }\n\n        &[aria-disabled=\"true\"] {\n            color: var(--input-placeholder-color);\n            border-color: var(--ops-line);\n            box-shadow: none;\n            cursor: not-allowed;\n\n            &:hover {\n                background: var(--white-color-lightest);\n                border-color: var(--ops-line);\n            }\n        }\n\n        &.ops-ver-apply:not([aria-disabled=\"true\"]) {\n            border-color: var(--primary-color-main);\n            color: var(--primary-color-main);\n\n            &:hover {\n                background: var(--primary-color-main);\n                border-color: var(--primary-color-main);\n                color: var(--white-color-lightest);\n            }\n        }\n    }\n\n    // ------------------------------------------------------------------\n    // 右: エディタ\n    // ------------------------------------------------------------------\n    .ops-editor {\n        flex: 1;\n        min-width: 0;\n        display: flex;\n        flex-direction: column;\n        background: var(--white-color-lightest);\n        border-radius: 8px;\n        overflow: hidden;\n    }\n\n    .ops-editor-head {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 16px;\n        padding: 0 16px;\n        min-height: 51px;\n        box-sizing: border-box;\n        border-bottom: 1px solid var(--border-weak-color);\n        flex-wrap: wrap;\n        row-gap: 8px;\n    }\n\n    // グループ切替。幅 380px 以上はセグメント型のタブ、未満はプルダウン（clamp の幅判定だけで切り替える）\n    .ops-editor-switch {\n        display: flex;\n        align-items: center;\n        min-width: 0;\n        flex: 1 1 200px;\n    }\n    .ops-editor-switch-tabs {\n        width: clamp(0px, calc((100% - 380px) * 999), 100%);\n        overflow: hidden;\n        flex-shrink: 0;\n    }\n    .ops-editor-switch-select {\n        width: clamp(0px, calc((380px - 100%) * 999), 240px);\n        max-width: 100%;\n        overflow: hidden;\n        flex-shrink: 0;\n\n        .ops-select-pill-wrap {\n            width: max-content;\n            max-width: 100%;\n        }\n    }\n\n    // セグメント型の切替（灰の台に白い選択中）\n    .ops-seg {\n        width: max-content;\n        display: flex;\n        padding: 3px;\n        gap: 2px;\n        border-radius: 18px;\n        background: var(--ops-seg-bg);\n        box-sizing: border-box;\n    }\n    .ops-seg-btn {\n        height: 26px;\n        min-height: 26px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 6px;\n        line-height: 1;\n        box-sizing: border-box;\n        padding: 0 14px;\n        border: none;\n        border-radius: 13px;\n        font-family: inherit;\n        font-size: 12.5px;\n        font-weight: 500;\n        cursor: pointer;\n        white-space: nowrap;\n        transition: background-color .2s, color .2s;\n        background: transparent;\n        color: var(--dark-color-main);\n\n        &.is-active {\n            background: var(--white-color-lightest);\n            color: var(--dark-color-dark);\n            font-weight: 700;\n            box-shadow: 0 1px 2px rgba(46, 50, 66, .18);\n        }\n    }\n    .ops-seg-dot {\n        width: 7px;\n        height: 7px;\n        border-radius: 50%;\n        background: var(--warning-color-main);\n        flex-shrink: 0;\n    }\n\n    .ops-select-pill-wrap {\n        position: relative;\n        display: flex;\n        align-items: center;\n\n        .bi-chevron-down {\n            position: absolute;\n            right: 12px;\n            font-size: 12px;\n            color: var(--dark-color-main);\n            pointer-events: none;\n        }\n\n        .ops-select-dot {\n            position: absolute;\n            left: 12px;\n            width: 7px;\n            height: 7px;\n            border-radius: 50%;\n            background: var(--warning-color-main);\n            pointer-events: none;\n        }\n\n        &.has-dot .ops-select-pill {\n            padding-left: 26px;\n        }\n    }\n\n    .ops-select-pill {\n        appearance: none;\n        -webkit-appearance: none;\n        height: 32px;\n        box-sizing: border-box;\n        padding: 0 32px 0 14px;\n        border: 1px solid var(--border-weak-color);\n        border-radius: 16px;\n        background: var(--white-color-lightest);\n        color: var(--dark-color-dark);\n        font-family: inherit;\n        font-size: 13px;\n        cursor: pointer;\n        max-width: 220px;\n\n        &.is-bold {\n            font-weight: 700;\n        }\n    }\n\n    .ops-editor-head-right {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        flex-shrink: 0;\n    }\n\n    .ops-unsaved-note {\n        display: inline-flex;\n        align-items: center;\n        gap: 6px;\n        line-height: 1;\n        font-size: 11.5px;\n        font-weight: 600;\n        color: var(--ops-draft-fg);\n        white-space: nowrap;\n    }\n    .ops-unsaved-dot,\n    .ops-pane-dot {\n        width: 7px;\n        height: 7px;\n        border-radius: 50%;\n        background: var(--warning-color-main);\n        flex-shrink: 0;\n    }\n\n    .ops-editor-toolbar {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 16px;\n        padding: 3px 16px;\n        min-height: 35px;\n        box-sizing: border-box;\n        border-bottom: 1px solid var(--border-weak-color);\n        background: var(--white-color-light);\n        flex-wrap: wrap;\n        row-gap: 4px;\n    }\n\n    .ops-md-tools {\n        display: flex;\n        align-items: center;\n        gap: 2px;\n        flex-wrap: wrap;\n    }\n\n    .ops-md-tool {\n        width: 28px;\n        height: 28px;\n        min-height: 28px;\n        padding: 0;\n        border: none;\n        border-radius: 4px;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 11px;\n        font-weight: 700;\n        background: transparent;\n        color: var(--dark-color-main);\n        outline: 1.5px solid transparent;\n        outline-offset: -1px;\n\n        .bi { font-size: 15px; }\n\n        &:hover {\n            background: var(--dark-color-dark-transparent-10);\n        }\n\n        &.is-active {\n            box-shadow: inset 0 0 0 999px var(--primary-color-lightest);\n            outline-color: var(--primary-color-main);\n            color: var(--primary-color-main);\n        }\n    }\n\n    // ツールバー右端のモデル名\n    .ops-model-badge {\n        display: inline-flex;\n        align-items: center;\n        gap: 4px;\n        margin-left: auto;\n        flex-shrink: 0;\n        font-size: 11.5px;\n        line-height: 1;\n        color: var(--font_active_sub_color);\n        white-space: nowrap;\n\n        .bi { font-size: 12px; }\n    }\n\n    .ops-lint-count {\n        display: inline-flex;\n        align-items: center;\n        gap: 3px;\n        font-size: 11px;\n        font-weight: 700;\n        line-height: 1;\n\n        .bi { font-size: 11px; }\n\n        &.is-error { color: var(--ops-error); }\n        &.is-warn {\n            color: var(--ops-warn-text);\n            .bi { color: var(--ops-warn); }\n        }\n    }\n\n    .ops-diff-summary {\n        font-size: 11px;\n        color: var(--ops-inuse-fg);\n\n        &.is-diff { color: var(--ops-draft-fg); }\n    }\n\n    .ops-char-count {\n        font-size: 11px;\n        color: var(--font_active_sub_color);\n    }\n\n    // システム／ユーザーの左右ペイン。エディタ幅 560px 未満は上下に積む（clamp の幅判定だけで切り替える）\n    .ops-editor-split {\n        flex: 1;\n        min-width: 0;\n        min-height: 0;\n        display: flex;\n        flex-wrap: wrap;\n        align-content: stretch;\n        overflow: hidden;\n    }\n\n    .ops-pane {\n        min-width: 0;\n        min-height: 0;\n        contain: size;\n        overflow: hidden;\n        display: flex;\n        flex-direction: column;\n\n        &.is-first {\n            flex: 0 0 max(var(--ops-split, 50%), clamp(0px, calc((560px - 100%) * 999), 100%));\n        }\n        &.is-second {\n            flex: 1 1 clamp(0px, calc((560px - 100%) * 999), 100%);\n            border-top: 1px solid var(--border-weak-color);\n            margin-top: -1px;\n        }\n    }\n\n    .ops-pane-head {\n        height: 34px;\n        flex-shrink: 0;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 8px;\n        padding: 0 12px 0 14px;\n        box-sizing: border-box;\n        background: var(--white-color-light);\n        border-bottom: 1px solid var(--ops-line);\n        overflow: hidden;\n        cursor: text;\n        transition: background-color .15s;\n    }\n    .ops-pane.is-focused .ops-pane-head {\n        background: var(--primary-color-lightest);\n\n        .ops-pane-title { color: var(--primary-color-main); }\n    }\n\n    .ops-pane-title {\n        display: flex;\n        align-items: center;\n        gap: 6px;\n        flex-shrink: 0;\n        font-size: 12px;\n        font-weight: 800;\n        letter-spacing: .5px;\n        white-space: nowrap;\n        color: var(--dark-color-dark);\n    }\n\n    .ops-pane-title-text {\n        cursor: pointer;\n    }\n\n    .ops-pane-outline-btn {\n        width: 24px;\n        height: 24px;\n        min-height: 24px;\n        padding: 0;\n        margin-left: -6px;\n        border-radius: 6px;\n        border: 1px solid var(--border-weak-color);\n        background: var(--white-color-lightest);\n        color: var(--dark-color-main);\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n        flex-shrink: 0;\n\n        .bi { font-size: 13px; line-height: 1; }\n\n        &:hover { border-color: var(--dark-color-main); }\n\n        &.is-open {\n            background: var(--primary-color-lightest);\n            color: var(--primary-color-main);\n            border-color: var(--primary-color-main);\n        }\n    }\n\n    .ops-pane-stats {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        min-width: 0;\n        overflow: hidden;\n        white-space: nowrap;\n    }\n\n    .ops-pane-discard {\n        height: 22px;\n        min-height: 22px;\n        padding: 0 8px;\n        border-radius: 11px;\n        background: var(--white-color-lightest);\n        border: 1px solid var(--border-weak-color);\n        color: var(--dark-color-dark);\n        cursor: pointer;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        gap: 4px;\n        line-height: 1;\n        font-family: inherit;\n        font-size: 11px;\n        font-weight: 500;\n        white-space: nowrap;\n        flex-shrink: 0;\n\n        .bi { font-size: 12px; line-height: 1; }\n\n        &:hover {\n            background: var(--dark-color-main);\n            color: #E8E9F1;\n            border-color: var(--dark-color-main);\n        }\n    }\n\n    .ops-pane-main {\n        flex: 1;\n        min-height: 0;\n        display: flex;\n        flex-direction: row;\n    }\n\n    // 分割ハンドル（上下積みのときは幅 0 で消える）\n    .ops-split-handle {\n        position: relative;\n        flex: 0 0 auto;\n        width: clamp(0px, calc((100% - 560px) * 999), 11px);\n        margin: 0 calc(-1 * clamp(0px, calc((100% - 560px) * 999), 5px));\n        contain: size;\n        overflow: hidden;\n        z-index: 2;\n        cursor: col-resize;\n        display: flex;\n        justify-content: center;\n        touch-action: none;\n\n        .ops-split-line {\n            width: 1px;\n            height: 100%;\n            background: var(--border-weak-color);\n            transition: background-color .15s;\n        }\n        .ops-split-grip {\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%);\n            width: 14px;\n            height: 34px;\n            border-radius: 7px;\n            background: var(--white-color-lightest);\n            border: 1px solid var(--border-weak-color);\n            box-sizing: border-box;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            color: #9aa0ad;\n            box-shadow: 0 1px 2px rgba(46, 50, 66, .12);\n\n            .bi { font-size: 12px; line-height: 1; }\n        }\n        &.is-dragging {\n            .ops-split-line {\n                width: 2px;\n                background: var(--primary-color-main);\n            }\n            .ops-split-grip {\n                border-color: var(--primary-color-main);\n                color: var(--primary-color-main);\n            }\n        }\n    }\n\n    .ops-outline {\n        width: 176px;\n        flex-shrink: 0;\n        border-right: 1px solid var(--ops-line);\n        overflow-y: auto;\n        padding: 10px 0;\n        box-sizing: border-box;\n        background: var(--ops-panel-bg);\n\n        .ops-outline-title {\n            font-size: 10px;\n            font-weight: 800;\n            letter-spacing: 1.5px;\n            color: var(--font_active_sub_color);\n            padding: 0 12px 8px;\n        }\n        .ops-outline-empty {\n            font-size: 11px;\n            color: var(--input-placeholder-color);\n            padding: 0 12px;\n        }\n    }\n\n    .ops-outline-item {\n        display: flex;\n        align-items: flex-start;\n        gap: 6px;\n        width: 100%;\n        border: none;\n        cursor: pointer;\n        text-align: left;\n        padding: 4px 10px 4px 0;\n        background: transparent;\n        color: var(--dark-color-main);\n\n        &:hover {\n            background: var(--dark-color-dark-transparent-10);\n        }\n\n        .ops-outline-level {\n            font-size: 9px;\n            line-height: 17px;\n            height: 17px;\n            color: var(--input-placeholder-color);\n            flex-shrink: 0;\n            font-family: var(--ops-mono);\n        }\n        .ops-outline-text {\n            font-size: 11.5px;\n            line-height: 17px;\n            word-break: break-word;\n            flex: 1;\n            min-width: 0;\n        }\n        .ops-outline-warn {\n            height: 17px;\n            font-size: 11px;\n            color: var(--ops-warn);\n        }\n\n        &.is-current {\n            background: var(--primary-color-lightest);\n            color: var(--primary-color-main);\n            font-weight: 700;\n        }\n    }\n\n    .ops-gutter {\n        overflow: hidden;\n        background: var(--ops-panel-bg);\n        border-right: 1px solid var(--ops-line);\n        position: relative;\n        flex-shrink: 0;\n        box-sizing: content-box;\n        transition: width .15s;\n\n        .ops-gutter-inner {\n            will-change: transform;\n        }\n    }\n\n    .ops-gutter-line {\n        height: 21px;\n        display: flex;\n        align-items: stretch;\n\n        .ops-gutter-bar {\n            width: 3px;\n            flex-shrink: 0;\n\n            &.is-added { background: var(--success-color-main); }\n            &.is-changed { background: var(--warning-color-main); }\n            &.is-removed { background: var(--danger-color-main); }\n        }\n        .ops-gutter-num {\n            flex: 1;\n            text-align: right;\n            padding: 0 8px 0 6px;\n            font-size: 11px;\n            font-family: var(--ops-mono);\n            line-height: 22px;\n            color: var(--input-placeholder-color);\n        }\n\n        &.is-error {\n            background: var(--ops-error-bg);\n            .ops-gutter-num { color: var(--ops-error-text); }\n        }\n        &.is-warn {\n            background: var(--ops-warn-bg);\n            .ops-gutter-num { color: var(--ops-warn-text); }\n        }\n    }\n\n    .ops-editor-area {\n        flex: 1;\n        min-width: 0;\n        position: relative;\n        display: flex;\n        overflow: hidden;\n    }\n\n    .ops-band-layer {\n        position: absolute;\n        inset: 0;\n        overflow: hidden;\n        pointer-events: none;\n\n        .ops-band-inner {\n            position: relative;\n            will-change: transform;\n        }\n    }\n\n    .ops-band {\n        position: absolute;\n        left: 0;\n        right: 0;\n        height: 21px;\n        box-sizing: border-box;\n\n        .ops-band-msg {\n            position: absolute;\n            right: 12px;\n            top: 0;\n            height: 20px;\n            display: flex;\n            align-items: center;\n            gap: 4px;\n            font-size: 10.5px;\n            font-weight: 600;\n            white-space: nowrap;\n\n            .bi { font-size: 11px; }\n        }\n\n        &.is-error {\n            background: var(--ops-error-bg);\n            border-bottom: 1px dashed var(--ops-error-border);\n            .ops-band-msg { color: var(--ops-error-text); }\n            .bi { color: var(--ops-error); }\n        }\n        &.is-warn {\n            background: var(--ops-warn-bg);\n            border-bottom: 1px dashed var(--ops-warn-border);\n            .ops-band-msg { color: var(--ops-warn-text); }\n            .bi { color: var(--ops-warn); }\n        }\n    }\n\n    .ops-editor-textarea {\n        flex: 1;\n        min-width: 0;\n        border: none;\n        outline: none;\n        resize: none;\n        padding: 12px 16px 12px 12px;\n        box-sizing: border-box;\n        font-family: var(--ops-mono);\n        font-size: 13px;\n        line-height: 21px;\n        color: var(--dark-color-dark);\n        background: transparent;\n        position: relative;\n        white-space: pre;\n        overflow: auto;\n        tab-size: 2;\n\n        &[readonly] {\n            color: var(--dark-color-main);\n        }\n    }\n\n    // 自動で送る情報（ツールバーのボタンと吹き出し）\n    .ops-auto-info {\n        position: relative;\n        display: inline-flex;\n        margin-left: 8px;\n    }\n\n    .ops-auto-info-button {\n        height: 24px;\n        min-height: 24px;\n        padding: 0 10px;\n        border-radius: 12px;\n        border: 1px solid var(--ops-latest-border);\n        background: var(--ops-latest-bg);\n        color: var(--ops-latest-fg);\n        font-size: 11.5px;\n        font-weight: 600;\n        cursor: pointer;\n        display: inline-flex;\n        align-items: center;\n        gap: 4px;\n        white-space: nowrap;\n\n        .bi { font-size: 12px; }\n\n        &:hover,\n        &.is-active {\n            border-color: var(--ops-latest-fg);\n        }\n    }\n\n    .ops-auto-info-pop {\n        position: absolute;\n        top: calc(100% + 4px);\n        left: 0;\n        z-index: 20;\n        width: 360px;\n        padding: 12px;\n        box-sizing: border-box;\n        border-radius: 8px;\n        border: 1px solid var(--border-weak-color);\n        background: var(--white-color-lightest);\n        box-shadow: 0 6px 20px rgba(46, 50, 66, .16);\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n    }\n\n    .ops-auto-info-lead {\n        font-size: 12px;\n        line-height: 1.6;\n        color: var(--dark-color-dark);\n    }\n\n    // 変数の入力アシスト（ツールバーのボタンと候補リスト）\n    .ops-var-tool {\n        position: relative;\n        display: inline-flex;\n    }\n\n    .ops-var-menu {\n        position: absolute;\n        z-index: 20;\n        display: flex;\n        flex-direction: column;\n        max-height: 280px;\n        box-sizing: border-box;\n        border-radius: 8px;\n        border: 1px solid var(--border-weak-color);\n        background: var(--white-color-lightest);\n        box-shadow: 0 6px 20px rgba(46, 50, 66, .16);\n        overflow: hidden;\n    }\n\n    .ops-var-list {\n        flex: 1;\n        min-height: 0;\n        overflow-y: auto;\n        padding: 4px;\n    }\n\n    .ops-var-item {\n        padding: 6px 10px;\n        border-radius: 6px;\n        cursor: pointer;\n\n        &.is-active {\n            background: var(--primary-color-lightest);\n        }\n    }\n\n    .ops-var-item-head {\n        display: flex;\n        align-items: baseline;\n        gap: 8px;\n        min-width: 0;\n\n        code {\n            flex-shrink: 0;\n            font-family: var(--ops-mono);\n            font-size: 12.5px;\n            font-weight: 700;\n            color: var(--dark-color-dark);\n        }\n    }\n\n    .ops-var-item.is-active .ops-var-item-head code {\n        color: var(--primary-color-main);\n    }\n\n    .ops-var-label {\n        min-width: 0;\n        font-size: 12px;\n        color: var(--dark-color-dark);\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    .ops-var-example {\n        margin-top: 2px;\n        font-size: 11px;\n        color: var(--font_active_sub_color);\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    .ops-var-hint {\n        flex-shrink: 0;\n        padding: 5px 12px;\n        border-top: 1px solid var(--ops-line);\n        background: var(--white-color-light);\n        font-size: 10.5px;\n        color: var(--font_active_sub_color);\n    }\n}\n\n// ------------------------------------------------------------------\n// 差分・保存モーダル（PageContent の外側にも出るため #AdminOpsPrompt の外で定義）\n// ------------------------------------------------------------------\n.ops-diff-dialog {\n    // 画面いっぱいの高さ（周囲はオーバーレイの余白だけ）\n    &.ops-dialog-overlay .ops-dialog {\n        height: 100%;\n        max-height: none;\n    }\n\n    // タイトル・グループ名・件数を横一列に並べる\n    .ops-dialog-title-area {\n        flex-direction: row;\n        align-items: center;\n        flex-wrap: wrap;\n        gap: 12px;\n    }\n\n    .ops-diff-count {\n        margin-left: 12px;\n        color: var(--font_active_sub_color);\n    }\n\n    .ops-diff-body {\n        padding: 0;\n        background: var(--white-color-lightest);\n        display: flex;\n        flex-direction: column;\n        overflow: hidden;\n    }\n\n    .ops-diff-toggle {\n        display: flex;\n        padding: 3px;\n        gap: 2px;\n        border-radius: 18px;\n        background: var(--ops-seg-bg);\n        box-sizing: border-box;\n    }\n\n    .ops-diff-mode {\n        height: 26px;\n        min-height: 26px;\n        padding: 0 14px;\n        border: none;\n        border-radius: 13px;\n        font-family: inherit;\n        font-size: 12.5px;\n        font-weight: 500;\n        cursor: pointer;\n        white-space: nowrap;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 6px;\n        line-height: 1;\n        transition: background-color .2s, color .2s;\n        background: transparent;\n        color: var(--dark-color-main);\n\n        &.is-active {\n            background: var(--white-color-lightest);\n            color: var(--dark-color-dark);\n            font-weight: 700;\n            box-shadow: 0 1px 2px rgba(46, 50, 66, .18);\n        }\n    }\n\n    // 差分が無いときの空状態\n    .ops-diff-empty {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        gap: 10px;\n        padding: 56px 24px;\n        text-align: center;\n\n        .bi { font-size: 32px; line-height: 1; color: #9aa0ad; }\n    }\n    .ops-diff-empty-title {\n        font-size: 14px;\n        font-weight: 700;\n        color: var(--dark-color-dark);\n    }\n    .ops-diff-empty-sub {\n        font-size: 12px;\n        color: var(--dark-color-main);\n    }\n    .ops-diff-empty-btn {\n        margin-top: 4px;\n        height: 30px;\n        min-height: 30px;\n        padding: 0 14px;\n        border-radius: 15px;\n        border: 1px solid var(--border-weak-color);\n        background: var(--white-color-lightest);\n        color: var(--dark-color-dark);\n        font-family: inherit;\n        font-size: 12px;\n        cursor: pointer;\n\n        &:hover { background: var(--dark-color-dark-transparent-10); }\n    }\n\n    .ops-diff-cols {\n        display: flex;\n        border-bottom: 1px solid var(--ops-line);\n        background: var(--white-color-light);\n        font-size: 11px;\n        font-weight: 800;\n        letter-spacing: 1px;\n        color: var(--dark-color-main);\n        flex-shrink: 0;\n\n        .ops-diff-col-title {\n            flex: 1;\n            padding: 8px 16px;\n\n            &:first-child { border-right: 1px solid var(--ops-line); }\n        }\n    }\n\n    .ops-diff-none {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        padding: 10px;\n        background: var(--white-color-light);\n        border-bottom: 1px solid var(--ops-line);\n        font-size: 12px;\n        color: var(--dark-color-main);\n        flex-shrink: 0;\n    }\n\n    .ops-diff-scroll {\n        flex: 1;\n        min-height: 0;\n        overflow: auto;\n        position: relative;\n        background: var(--white-color-lightest);\n    }\n\n    // 省略行（クリックで展開）\n    .ops-diff-gap {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 6px;\n        padding: 4px 0;\n        border: none;\n        border-top: 1px solid var(--ops-line);\n        border-bottom: 1px solid var(--ops-line);\n        background: #f3f5f8;\n        font-family: inherit;\n        font-size: 11px;\n        color: var(--dark-color-main);\n        cursor: pointer;\n\n        .bi { font-size: 11px; }\n        &:hover { background: #e8ecf2; color: var(--dark-color-dark); }\n    }\n\n    .ops-diff-line {\n        display: flex;\n        align-items: stretch;\n        position: relative;\n\n        // 選択中の変更のかたまり\n        .ops-diff-cur {\n            position: absolute;\n            left: 0;\n            top: 0;\n            bottom: 0;\n            width: 3px;\n            background: var(--dark-color-dark);\n            z-index: 1;\n        }\n        .ops-diff-half {\n            flex: 1;\n            min-width: 0;\n            display: flex;\n\n            &.is-left { border-right: 1px solid var(--ops-line); }\n        }\n        .ops-diff-ln {\n            width: 44px;\n            min-width: 44px;\n            text-align: right;\n            padding: 0 6px 0 0;\n            font-size: 10.5px;\n            line-height: 22px;\n            font-family: var(--ops-mono);\n            color: #b2bcca;\n            user-select: none;\n            box-sizing: border-box;\n        }\n        .ops-diff-sign {\n            width: 18px;\n            min-width: 18px;\n            text-align: center;\n            font-size: 12px;\n            line-height: 22px;\n            font-family: var(--ops-mono);\n            font-weight: 700;\n            user-select: none;\n        }\n        .is-left .ops-diff-sign { color: #c8394f; }\n        .is-right .ops-diff-sign { color: #1f7a5e; }\n        .ops-diff-text {\n            flex: 1;\n            min-width: 0;\n            font-size: 13px;\n            line-height: 22px;\n            white-space: pre-wrap;\n            word-break: break-word;\n            padding-right: 16px;\n        }\n        .ops-diff-hl { border-radius: 2px; }\n\n        &.is-eq {\n            .is-left .ops-diff-text { color: var(--dark-color-main); }\n            .is-right .ops-diff-text { color: var(--dark-color-dark); }\n        }\n        &.is-chg, &.is-del {\n            .is-left { background: #fff1f3; .ops-diff-text { color: #a32a3e; } .ops-diff-hl { background: #ffc6d0; } }\n        }\n        &.is-chg, &.is-add {\n            .is-right { background: #ecf8f3; .ops-diff-text { color: #1f6b53; } .ops-diff-hl { background: #b5e8d2; } }\n        }\n        // 相手側に行が無い側\n        &.is-del .is-right, &.is-add .is-left {\n            background: repeating-linear-gradient(135deg, #f6f7f9 0 6px, #eef0f3 6px 12px);\n        }\n    }\n\n    // 追加・削除・書き換えの行数\n    .ops-diff-stat {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        font-size: 12px;\n        font-weight: 700;\n        font-variant-numeric: tabular-nums;\n        white-space: nowrap;\n\n        .is-add { color: #1f7a5e; }\n        .is-del { color: #c8394f; }\n        .is-chg { color: #8a6a16; }\n    }\n\n    // 変更箇所の前後移動\n    .ops-diff-nav {\n        display: flex;\n        align-items: center;\n        gap: 2px;\n        padding: 2px;\n        border-radius: 16px;\n        border: 1px solid var(--border-weak-color);\n\n        .ops-diff-nav-btn {\n            width: 26px;\n            height: 26px;\n            min-height: 26px;\n            padding: 0;\n            border: none;\n            border-radius: 13px;\n            background: transparent;\n            color: var(--dark-color-main);\n            cursor: pointer;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n\n            .bi { font-size: 13px; }\n            &:hover { background: var(--ops-seg-bg); color: var(--dark-color-dark); }\n        }\n        .ops-diff-nav-label {\n            min-width: 72px;\n            text-align: center;\n            white-space: nowrap;\n            font-size: 12px;\n            color: var(--dark-color-dark);\n            font-variant-numeric: tabular-nums;\n        }\n    }\n\n    .ops-diff-mode-count {\n        min-width: 16px;\n        height: 16px;\n        padding: 0 5px;\n        border-radius: 8px;\n        box-sizing: border-box;\n        font-size: 10px;\n        font-weight: 700;\n        line-height: 16px;\n        text-align: center;\n        background: var(--primary-color-main);\n        color: var(--white-color-lightest);\n    }\n\n    // 保存モーダルのメモ欄（差分の上に固定）\n    .ops-save-message {\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n        padding: 16px 24px;\n        border-bottom: 1px solid var(--ops-line);\n        flex-shrink: 0;\n\n        .ops-save-message-label {\n            font-size: 12px;\n            font-weight: 800;\n            letter-spacing: 1px;\n        }\n        .ops-save-message-input {\n            min-height: 0;\n            max-height: 30vh;\n        }\n    }\n\n    .ops-diff-apply-note {\n        flex: 1;\n        min-width: 240px;\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        font-size: 12px;\n        color: var(--ops-draft-fg);\n\n        .bi { font-size: 14px; }\n    }\n}\n\n// 版の状態タグ（版パネルと使い方ポップアップで共用）\n.ops-scope {\n    // システムが自動で送る情報の一覧（ツールバーの吹き出しと使い方で共用）\n    .ops-auto-list {\n        display: flex;\n        flex-direction: column;\n        gap: 2px;\n    }\n    .ops-auto-item {\n        display: flex;\n        align-items: baseline;\n        gap: 8px;\n        padding: 4px 8px;\n        border-radius: 6px;\n        background: var(--white-color-light);\n        font-size: 12px;\n        min-width: 0;\n    }\n    .ops-auto-label {\n        flex-shrink: 0;\n        font-weight: 600;\n        color: var(--dark-color-dark);\n    }\n    .ops-auto-example {\n        min-width: 0;\n        font-size: 11px;\n        color: var(--font_active_sub_color);\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    // ボタンと見分けられるよう枠線なしの角丸タグにする\n    .ops-ver-tag {\n        display: inline-flex;\n        align-items: center;\n        padding: 0 6px;\n        border-radius: 4px;\n        font-size: 11px;\n        font-weight: 500;\n        line-height: 18px;\n        flex-shrink: 0;\n        white-space: nowrap;\n        cursor: default;\n\n        &.is-deployed {\n            background: var(--primary-color-lightest);\n            color: var(--primary-color-dark);\n        }\n        &.is-draft {\n            background: var(--ops-draft-bg);\n            color: #7a5c0f;\n        }\n    }\n\n    .ops-form-card {\n        background: var(--white-color-lightest);\n        border-radius: 8px;\n        padding: 24px;\n        box-sizing: border-box;\n        display: flex;\n        flex-direction: column;\n        gap: 12px;\n    }\n}\n\n// ページタイトル横の使い方ボタン\n.ops-title-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.ops-help-button {\n    width: 24px;\n    height: 24px;\n    min-height: 24px;\n    padding: 0;\n    border: none;\n    border-radius: 50%;\n    background: transparent;\n    color: var(--font_active_sub_color);\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n\n    .bi { font-size: 18px; line-height: 1; }\n\n    &:hover {\n        color: var(--primary-color-main);\n        background: var(--primary-color-lightest);\n    }\n}\n\n// 使い方ポップアップ\n.ops-help-dialog {\n    .ops-help {\n        display: flex;\n        flex-direction: column;\n        gap: 20px;\n        font-size: 13px;\n        line-height: 1.7;\n        color: var(--dark-color-dark);\n\n        code, kbd {\n            font-family: var(--ops-mono);\n        }\n    }\n\n    // タブ（1度に見せる量を絞る）\n    .ops-help-tabs {\n        display: flex;\n        gap: 4px;\n        padding: 4px;\n        border-radius: 10px;\n        background: var(--input-bg-color);\n        border: 1px solid var(--ops-line);\n    }\n    .ops-help-tab {\n        flex: 1;\n        min-height: 36px;\n        border: none;\n        border-radius: 7px;\n        background: transparent;\n        color: var(--font_active_sub_color);\n        font-size: 13px;\n        font-weight: 600;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 6px;\n\n        .bi { font-size: 15px; }\n\n        &:hover { color: var(--dark-color-dark); }\n        &.is-active {\n            background: var(--white-color-lightest);\n            color: var(--primary-color-main);\n            box-shadow: 0 1px 3px rgba(46, 50, 66, .15);\n        }\n    }\n    .ops-help-panel {\n        min-height: 340px;\n        display: flex;\n        flex-direction: column;\n        gap: 16px;\n    }\n\n    // はじめに: 3ステップ\n    .ops-help-steps {\n        display: flex;\n        align-items: stretch;\n        gap: 8px;\n    }\n    .ops-help-step {\n        position: relative;\n        flex: 1;\n        padding: 20px 16px;\n        border-radius: 12px;\n        background: var(--white-color-light);\n        border: 1px solid var(--ops-line);\n        text-align: center;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 8px;\n    }\n    // 手順の番号（カードの左上）\n    .ops-help-step-num {\n        position: absolute;\n        top: 10px;\n        left: 14px;\n        font-size: 20px;\n        font-weight: 800;\n        line-height: 1;\n        color: var(--primary-color-main);\n        font-family: var(--ops-mono);\n    }\n    .ops-help-step-icon {\n        width: 52px;\n        height: 52px;\n        border-radius: 50%;\n        background: var(--primary-color-lightest);\n        color: var(--primary-color-main);\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        .bi { font-size: 24px; }\n    }\n    .ops-help-step-title {\n        font-size: 16px;\n        font-weight: 800;\n        letter-spacing: 1px;\n    }\n    .ops-help-step-text {\n        font-size: 12px;\n        color: var(--font_active_sub_color);\n        line-height: 1.6;\n    }\n    .ops-help-step-arrow {\n        align-self: center;\n        color: var(--border-color);\n        font-size: 18px;\n    }\n\n    .ops-help-callout {\n        display: flex;\n        gap: 10px;\n        align-items: flex-start;\n        padding: 12px 14px;\n        border-radius: 10px;\n\n        > .bi { font-size: 16px; margin-top: 2px; }\n\n        // 中の「警告」ラベルと同化しないよう白地＋黄色枠\n        &.is-warn {\n            background: var(--white-color-light);\n            border: 1px solid var(--ops-warn-border);\n            color: var(--ops-warn-text);\n        }\n\n        // 1行に1種類。ラベル幅を揃えて説明の書き出しを合わせる\n        .ops-help-severity {\n            display: grid;\n            grid-template-columns: auto 1fr;\n            gap: 6px 10px;\n            margin-top: 8px;\n        }\n        .ops-help-sev-item { display: contents; }\n        .ops-help-sev { justify-self: start; }\n    }\n\n    // 画面の見方: 見本＋一言\n    .ops-help-legend {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        gap: 10px;\n    }\n    .ops-help-legend-item {\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        padding: 10px 12px;\n        border-radius: 10px;\n        background: var(--white-color-light);\n        border: 1px solid var(--ops-line);\n        font-size: 12px;\n        color: var(--font_active_sub_color);\n\n        b { color: var(--dark-color-dark); }\n    }\n    .ops-help-legend-visual {\n        width: 84px;\n        flex-shrink: 0;\n        display: flex;\n        justify-content: center;\n    }\n    .ops-help-band {\n        display: block;\n        width: 60px;\n        height: 22px;\n        border-radius: 3px;\n        background: color-mix(in srgb, var(--primary-color-main) 6%, var(--white-color-lightest));\n        box-shadow: inset 3px 0 0 var(--primary-color-main);\n    }\n    .ops-help-star {\n        color: #e0a400;\n        font-size: 16px;\n    }\n    .ops-help-pencil {\n        color: var(--input-placeholder-color);\n        font-size: 14px;\n    }\n    .ops-help-chip {\n        display: inline-flex;\n        align-items: center;\n        gap: 4px;\n        height: 24px;\n        padding: 0 8px;\n        border-radius: 6px;\n        border: 1px solid var(--border-color);\n        background: var(--white-color-lightest);\n        font-size: 11px;\n        white-space: nowrap;\n        color: var(--dark-color-dark);\n    }\n\n    // エラー／警告の凡例（書き方のルール の注意ブロック内）\n    .ops-help-severity {\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n        gap: 6px 18px;\n        font-size: 12px;\n        color: var(--font_active_sub_color);\n    }\n    // ラベルと説明を同じ行に保つ\n    .ops-help-sev-item {\n        display: inline-flex;\n        align-items: center;\n        gap: 10px;\n    }\n    .ops-help-sev {\n        flex-shrink: 0;\n        display: inline-flex;\n        align-items: center;\n        gap: 4px;\n        padding: 0 8px;\n        border-radius: 10px;\n        font-weight: 700;\n        line-height: 22px;\n\n        &.is-error { color: var(--ops-error-text); background: var(--ops-error-bg); }\n        &.is-warn { color: var(--ops-warn-text); background: var(--ops-warn-bg); }\n    }\n    .ops-help-cards {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        gap: 10px;\n    }\n    .ops-help-card {\n        padding: 14px;\n        border-radius: 10px;\n        background: var(--white-color-light);\n        border: 1px solid var(--ops-line);\n        display: flex;\n        flex-direction: column;\n        gap: 6px;\n\n        &.is-wide { grid-column: 1 / -1; }\n    }\n    .ops-help-card-title {\n        display: flex;\n        align-items: center;\n        gap: 6px;\n        font-size: 14px;\n        font-weight: 800;\n\n        .bi { color: var(--primary-color-main); font-size: 16px; }\n    }\n    .ops-help-card-text {\n        font-size: 12px;\n        color: var(--font_active_sub_color);\n    }\n    .ops-help-examples {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n    }\n    .ops-help-example-arrow {\n        color: var(--border-color);\n    }\n    .ops-help-example {\n        display: inline-flex;\n        align-items: center;\n        gap: 6px;\n        align-self: flex-start;\n        padding: 3px 10px 3px 8px;\n        border-radius: 6px;\n        font-size: 12px;\n\n        code { font-size: 12px; }\n        &.is-good { background: #e8f6f1; color: #1f7a5e; }\n        &.is-bad { background: var(--ops-error-bg); color: var(--ops-error-text); }\n    }\n    .ops-help-vars {\n        margin-top: 6px;\n        padding-top: 10px;\n        border-top: 1px dashed var(--ops-line);\n        display: flex;\n        flex-direction: column;\n        gap: 6px;\n    }\n    .ops-help-vars-label {\n        font-size: 11px;\n        font-weight: 800;\n        letter-spacing: 1px;\n        color: var(--font_active_sub_color);\n    }\n    .ops-help-vars-row {\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n        gap: 6px;\n        font-size: 12px;\n\n        code {\n            padding: 0 6px;\n            border-radius: 4px;\n            background: var(--white-color-lightest);\n            border: 1px solid var(--ops-line);\n            font-size: 11.5px;\n        }\n    }\n    .ops-help-vars-tab {\n        min-width: 150px;\n        color: var(--font_active_sub_color);\n    }\n    .ops-help-vars-none {\n        color: var(--font_active_sub_color);\n    }\n    .ops-help-more {\n        align-self: flex-start;\n        border: none;\n        background: transparent;\n        padding: 0;\n        color: #1F5FAF;\n        font-size: 12px;\n        cursor: pointer;\n        display: inline-flex;\n        align-items: center;\n        gap: 4px;\n    }\n\n    // ショートカット: キーキャップ\n    .ops-help-keys {\n        display: flex;\n        flex-direction: column;\n    }\n    .ops-help-lead {\n        margin-bottom: 4px;\n        font-size: 12px;\n        font-weight: 800;\n        letter-spacing: 1px;\n        color: var(--font_active_sub_color);\n    }\n    .ops-help-key-row {\n        display: flex;\n        align-items: center;\n        gap: 16px;\n        padding: 10px 4px;\n        border-bottom: 1px solid var(--ops-line);\n    }\n    .ops-help-key-caps {\n        width: 200px;\n        flex-shrink: 0;\n        display: flex;\n        align-items: center;\n        gap: 4px;\n\n        kbd {\n            min-width: 28px;\n            padding: 3px 8px;\n            border-radius: 6px;\n            border: 1px solid var(--border-color);\n            border-bottom-width: 3px;\n            background: var(--white-color-lightest);\n            font-size: 12px;\n            text-align: center;\n        }\n    }\n    .ops-help-key-plus {\n        color: var(--font_active_sub_color);\n        font-size: 11px;\n    }\n    .ops-help-key-text {\n        font-size: 13px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
